export default [
    {
        "acct2302": {
            "Prereq": "ACCT 2301 "
        },
        "acct3100": {
            "Prereq": "BA 1100"
        },
        "acct3101": {
            "Prereq": "SPX Prerequisite: PPA students only"
        },
        "acct3322": {
            "Prereq": "(ACCT 2301 ) and (ACCT 2302 ) and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "acct3331": {
            "Prereq": "(MATH 1325 or MATH 2413 or MATH 2417) and (ACCT 2302 )"
        },
        "acct3332": {
            "Prereq": "ACCT 3331 "
        },
        "acct3341": {
            "Prereq": "ACCT 2302 "
        },
        "acct3350": {
            "Prereq": "BLAW 2301 and (ACCT 2302 )"
        },
        "acct4301": {
            "Prereq": "(ACCT 2302 ) and ITSS 3300 and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "acct4302": {
            "Prereq": "ACCT 3332 "
        },
        "acct4334": {
            "Prereq": "ACCT 3331 "
        },
        "acct4336": {
            "Prereq": "ACCT 3331 "
        },
        "acct4337": {
            "Prereq": "(ACCT 3331 ) and FIN 3320"
        },
        "acct4340": {
            "Prereq": "ACCT 3331 "
        },
        "acct4342": {
            "PreOrCoreq": "ACCT 3332"
        },
        "acct4395": {
            "Prereq": "SPX Prerequisites: (BCOM 4300 or BCOM 4350) and Junior or Senior standing"
        },
        "acct4v80": {
            "Prereq": "SPX Prerequisites: Students must have completed 12 hours of upper level accounting courses with a minimum GPA of 3"
        },
        "acts4301": {
            "Prereq": "STAT 4351 and ACTS 4308"
        },
        "acts4302": {
            "Prereq": "STAT 4351 and ACTS 4308"
        },
        "acts4303": {
            "Prereq": "SPX Prerequisites: ACTS 4301 with a grade C- or higher and instructor consent required"
        },
        "acts4304": {
            "Prereq": "STAT 4352"
        },
        "acts4305": {
            "Prereq": "SPX Prerequisites: ACTS 4304 with a grade C- or higher and instructor consent required"
        },
        "acts4306": {
            "Prereq": "SPX Prerequisite: STAT 4351 or instructor consent required"
        },
        "acts4307": {
            "Prereq": "STAT 3355 and STAT 4352"
        },
        "acts4308": {
            "Prereq": "MATH 2415 or MATH 2419"
        },
        "acts4309": {
            "Prereq": "ACTS 4302"
        },
        "ahst3313": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3315": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3316": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3317": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3318": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3319": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3320": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst3322": {
            "Prereq": "ARTS 1301 "
        },
        "ahst3324": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst4342": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "ahst4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "ams4381": {
            "Prereq": "SPX Prerequisite: Completion of at least 39 and no more than 45 hours of work towards a degree in American Studies and instructor consent required"
        },
        "arab1312": {
            "Prereq": "SPX Prerequisite: ARAB 1311 or equivalent or instructor consent required"
        },
        "arab2311": {
            "Prereq": "SPX Prerequisite: ARAB 1312 or equivalent or instructor consent required"
        },
        "arab2312": {
            "Prereq": "SPX Prerequisite: ARAB 2311 or equivalent or instructor consent required"
        },
        "arhm1100": {
            "Coreq": "UNIV 1010"
        },
        "arhm3342": {
            "Prereq": "SPX Prerequisites: RHET 1302 and Completion of 040 Core"
        },
        "arhm4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "arts3311": {
            "Prereq": "ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381"
        },
        "arts3313": {
            "Prereq": "ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381"
        },
        "arts3315": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381 or instructor consent required"
        },
        "arts3340": {
            "Prereq": "ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381"
        },
        "arts3341": {
            "Prereq": "ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381"
        },
        "arts3363": {
            "Prereq": "ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381"
        },
        "arts3364": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2380 or instructor consent required"
        },
        "arts3366": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2380 or instructor consent required"
        },
        "arts3367": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2380 or instructor consent required"
        },
        "arts3368": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 ARTS 2380 or ARTS 2381"
        },
        "arts3369": {
            "Prereq": "SPX Prerequisite: ARTS 2316 or instructor consent required"
        },
        "arts3371": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ATCM 2301 or ATCM 2302 or instructor consent required"
        },
        "arts3372": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ATCM 2301 or ATCM 2302 or instructor consent required"
        },
        "arts3373": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2380 or instructor consent required"
        },
        "arts3375": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2380 or ARTS 2381 or instructor consent required"
        },
        "arts3376": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381 or instructor consent required"
        },
        "arts3377": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ATCM 2301 or ATCM 2302 or instructor consent required"
        },
        "arts3378": {
            "Prereq": "SPX Prerequisite: ARTS 2381 or ARTS 2380 or instructor consent required"
        },
        "arts3379": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ATCM 2301 or ATCM 2302 or instructor consent required"
        },
        "arts3381": {
            "Prereq": "SPX Prerequisite: ARTS 2380 or instructor consent required"
        },
        "arts3382": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381 or instructor consent required"
        },
        "arts4305": {
            "Prereq": "SPX Prerequisites: ((ARTS 2315 or ARTS 2380) and ARTS 3363) or instructor consent required"
        },
        "arts4310": {
            "Prereq": "SPX Prerequisite: ARTS 1316 or ARTS 2316 or ARTS 2350 or ARTS 2380 or ARTS 2381 or instructor consent required"
        },
        "arts4366": {
            "Prereq": "SPX Prerequisite: ARTS 3366 or ARTS 3367 or ARTS 3369 or ARTS 3373 or instructor consent required"
        },
        "arts4368": {
            "Prereq": "SPX Prerequisite: 6 SCH of upper-division ARTS courses or instructor consent required"
        },
        "arts4372": {
            "Prereq": "SPX Prerequisite: ARTS 3371 or ARTS 3372 or ARTS 3376 or ARTS 3377 or ARTS 3379 or instructor consent required"
        },
        "arts4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "atcm1100": {
            "Coreq": "UNIV 1010"
        },
        "atcm2320": {
            "PreOrCoreq": "RHET 1302"
        },
        "atcm2321": {
            "Prereq": "RHET 1302"
        },
        "atcm2322": {
            "Prereq": "RHET 1302"
        },
        "atcm2335": {
            "Prereq": "ATCM 2301"
        },
        "atcm3300": {
            "Prereq": "ATCM 2300"
        },
        "atcm3301": {
            "Prereq": "RHET 1302"
        },
        "atcm3303": {
            "Prereq": "ATCM 2303"
        },
        "atcm3304": {
            "Prereq": "ATCM 2310"
        },
        "atcm3305": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3306": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3307": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3308": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3309": {
            "Prereq": "SPX Prerequisites: (ATCM 2310 with a grade of C or better) and department consent required"
        },
        "atcm3310": {
            "Prereq": "CS 1335 and (ATCM 2310 )"
        },
        "atcm3311": {
            "Prereq": "CS 1335 and (ATCM 2310 )"
        },
        "atcm3312": {
            "Prereq": "SPX Prerequisites: ATCM 3306 and department consent required"
        },
        "atcm3320": {
            "PreOrCoreq": "ATCM 2321 or ATCM 2322"
        },
        "atcm3323": {
            "Prereq": "RHET 1302"
        },
        "atcm3325": {
            "Prereq": "RHET 1302"
        },
        "atcm3331": {
            "Prereq": "ATCM 2300"
        },
        "atcm3335": {
            "Prereq": "CS 1335"
        },
        "atcm3337": {
            "Prereq": "ATCM 2302"
        },
        "atcm3338": {
            "Prereq": "ATCM 2301"
        },
        "atcm3340": {
            "Prereq": "ATCM 2302"
        },
        "atcm3345": {
            "Prereq": "ATCM 2345"
        },
        "atcm3346": {
            "Prereq": "ATCM 2345"
        },
        "atcm3350": {
            "Prereq": "ATCM 2302"
        },
        "atcm3355": {
            "Prereq": "ATCM 2355 or ATCM 2301 or ATCM 3306"
        },
        "atcm3356": {
            "Prereq": "ATCM 2302 or ATCM 2355 or ATCM 3306 or ATCM 3355"
        },
        "atcm3357": {
            "Prereq": "SPX Prerequisites: (ATCM 2355 or ATCM 3355) and department consent required"
        },
        "atcm3365": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3366": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3367": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3368": {
            "Prereq": "SPX Prerequisite: ATCM 2310 with a grade of C or better or Instructor consent required"
        },
        "atcm3369": {
            "Prereq": "ATCM 3365"
        },
        "atcm3370": {
            "Prereq": "ATCM 3306"
        },
        "atcm3371": {
            "Prereq": "ATCM 2310 "
        },
        "atcm3372": {
            "Prereq": "ATCM 2345"
        },
        "atcm3375": {
            "Prereq": "ATCM 3365"
        },
        "atcm3381": {
            "Prereq": "PSY 2317"
        },
        "atcm4304": {
            "Prereq": "ATCM 3304"
        },
        "atcm4305": {
            "Prereq": "SPX Prerequisites: ATCM 3305 with a grade of B or better and department consent required"
        },
        "atcm4306": {
            "Prereq": "SPX Prerequisites: ATCM 3306 with a grade of B or better and department consent required"
        },
        "atcm4307": {
            "Prereq": "SPX Prerequisites: ATCM 3307 with a grade of B or better and department consent required"
        },
        "atcm4308": {
            "Prereq": "SPX Prerequisites: ATCM 3308 with a grade of B or better and department consent required"
        },
        "atcm4309": {
            "Prereq": "SPX Prerequisites: ATCM 3309 with a grade of B or higher and department consent required"
        },
        "atcm4310": {
            "Prereq": "ATCM 3305 or ATCM 3306 or ATCM 3307 or ATCM 3308"
        },
        "atcm4312": {
            "Prereq": "SPX Prerequisites: ATCM 4306 with a grade of B or higher"
        },
        "atcm4313": {
            "Prereq": "SPX Prerequisites: (ATCM 3305 or ATCM 3306 or ATCM 3307 or ATCM 3308) with a grade of B or higher and department consent required"
        },
        "atcm4314": {
            "Prereq": "SPX Prerequisites: (ATCM 3305 or ATCM 3306 or ATCM 3307 or ATCM 3308) with a grade of B or higher and department consent required"
        },
        "atcm4315": {
            "Prereq": "SPX Prerequisites: ATCM 4305 with a grade of B or higher and department consent required"
        },
        "atcm4317": {
            "Prereq": "SPX Prerequisites: ATCM 4316 and department consent required"
        },
        "atcm4320": {
            "Prereq": "ATCM 2321 or ATCM 2322"
        },
        "atcm4322": {
            "Prereq": "SPX Prerequisite: ATCM 3321 or instructor consent required"
        },
        "atcm4323": {
            "Prereq": "SPX Prerequisite: ATCM 3321 or instructor consent required"
        },
        "atcm4325": {
            "Prereq": "SPX Prerequisite: ATCM 3321 or instructor consent required"
        },
        "atcm4326": {
            "Prereq": "SPX Prerequisite: ATCM 3320 or Instructor consent required"
        },
        "atcm4330": {
            "Prereq": "SPX Prerequisite: ATCM 3320 or ATCM 3321 or ATCM 3330 or instructor consent required"
        },
        "atcm4337": {
            "Prereq": "ATCM 3337"
        },
        "atcm4338": {
            "Prereq": "ATCM 3338"
        },
        "atcm4340": {
            "Prereq": "ATCM 3337"
        },
        "atcm4345": {
            "Prereq": "ATCM 3345"
        },
        "atcm4346": {
            "Prereq": "ATCM 3346"
        },
        "atcm4350": {
            "Prereq": "ATCM 3350"
        },
        "atcm4357": {
            "Prereq": "SPX Prerequisites: ATCM 3357 and instructor consent required"
        },
        "atcm4365": {
            "Prereq": "ATCM 3365"
        },
        "atcm4366": {
            "Prereq": "ATCM 3366"
        },
        "atcm4367": {
            "Prereq": "ATCM 3367"
        },
        "atcm4368": {
            "Prereq": "ATCM 3368"
        },
        "atcm4370": {
            "Prereq": "SPX Prerequisites: ATCM 3370 with a grade of B or higher and department consent required"
        },
        "atcm4373": {
            "Prereq": "ATCM 3305"
        },
        "atcm4375": {
            "Prereq": "ATCM 4365"
        },
        "atcm4v96": {
            "Prereq": "SPX Prerequisites: Upper-division standing and completion of all lower-division requirements in ATEC and instructor consent required"
        },
        "ba1100": {
            "Coreq": "UNIV 1010"
        },
        "ba3100": {
            "Prereq": "BA 1100"
        },
        "ba3300": {
            "Prereq": "BA 1310 or ECON 2302"
        },
        "bbsu1100": {
            "Coreq": "UNIV 1010"
        },
        "bcom1300": {
            "Coreq": "UNIV 1010"
        },
        "bcom3100": {
            "Prereq": "BA 1100"
        },
        "bcom3310": {
            "Prereq": "ACCT 3100 or BA 3100 or BCOM 3100 or FIN 3100 or HMGT 3100 or IMS 3100 or MKT 3100 or ITSS 3100 or OPRE 3100 or ACCT 3200 or BA 3200 or BCOM 3200 or FIN 3200 or HMGT 3200 or IMS 3200 or ITSS 3200 or MKT 3200 or OBHR 3200 or OPRE 3200"
        },
        "bcom4300": {
            "Prereq": "BCOM 1300 or BCOM 3300"
        },
        "bcom4310": {
            "Prereq": "BCOM 1300 or BCOM 3300 or BCOM 3310"
        },
        "bcom4350": {
            "Prereq": "(BCOM 3310 ) and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "biol2111": {
            "Coreq": "BIOL 2311"
        },
        "biol2112": {
            "Coreq": "BIOL 2312"
        },
        "biol2281": {
            "Prereq": "BIOL 2311 "
        },
        "biol2311": {
            "Coreq": "BIOL 2111"
        },
        "biol2312": {
            "Coreq": "BIOL 2112"
        },
        "biol3101": {
            "Coreq": "BIOL 3301"
        },
        "biol3102": {
            "Coreq": "BIOL 3302"
        },
        "biol3161": {
            "Coreq": "BIOL 3361 or CHEM 3361"
        },
        "biol3162": {
            "Coreq": "BIOL 3362 or CHEM 3362"
        },
        "biol3301": {
            "Coreq": "BIOL 3101"
        },
        "biol3302": {
            "Coreq": "BIOL 3102"
        },
        "biol3303": {
            "Prereq": "(BIOL 2281 ) and BIOL 2311 and BIOL 2312"
        },
        "biol3305": {
            "Prereq": "BIOL 3301"
        },
        "biol3312": {
            "Prereq": "(BIOL 2281 ) and BIOL 2311 and BIOL 2312"
        },
        "biol3315": {
            "Prereq": "SPX Prerequisites: (BIOL 3101 and BIOL 3301) or equivalent or instructor consent required"
        },
        "biol3320": {
            "Prereq": "BIOL 2281  and (BIOL 2311 and (BIOL 2111 )) and (BIOL 2312 and (BIOL 2112))"
        },
        "biol3335": {
            "Prereq": "BIOL 2311 and (BIOL 3361 or CHEM 3361)"
        },
        "biol3336": {
            "Prereq": "BIOL 3361 or CHEM 3361"
        },
        "biol3351": {
            "Prereq": "BIOL 2311 and BIOL 2312 "
        },
        "biol3355": {
            "Prereq": "BIOL 2281 and BIOL 2312"
        },
        "biol3357": {
            "Prereq": "BIOL 3455  and BIOL 3456 "
        },
        "biol3361": {
            "Coreq": "BIOL 3161"
        },
        "biol3362": {
            "Coreq": "BIOL 3162"
        },
        "biol3370": {
            "Prereq": "BIOL 2312 and (BIOL 3455 or BIOL 3456 )"
        },
        "biol3380": {
            "PreOrCoreq": "BIOL 3361 or CHEM 3361"
        },
        "biol3385": {
            "Prereq": "BIOL 2311 and BIOL 2312"
        },
        "biol3388": {
            "Prereq": "(BIOL 2281 or CHEM 2401 ) and BIOL 2311 and BIOL 2312"
        },
        "biol3455": {
            "Prereq": "BIOL 2312 "
        },
        "biol3456": {
            "Prereq": "BIOL 3455 "
        },
        "biol3520": {
            "Prereq": "(BIOL 2281 or CHEM 2401 ) and (BIOL 2311 and BIOL 2312)  and CHEM 2323"
        },
        "biol3v00": {
            "Prereq": "(BIOL 2281 or CHEM 2401 ) and BIOL 2311 and BIOL 2312 "
        },
        "biol3v01": {
            "Prereq": "(BIOL 2281 or CHEM 2401 ) and BIOL 2311 and BIOL 2312 "
        },
        "biol3v40": {
            "Prereq": "(BIOL 2281 or CHEM 2401 ) and BIOL 2311 and BIOL 2312 "
        },
        "biol3v82": {
            "Prereq": "SPX Prerequisite: BIOL 3V81"
        },
        "biol4305": {
            "Prereq": "BIOL 3301 and BIOL 3302"
        },
        "biol4310": {
            "Prereq": "BIOL 2311"
        },
        "biol4315": {
            "Prereq": "BIOL 2311 and BIOL 2312 and (BIOL 2281 or CHEM 2401 )"
        },
        "biol4317": {
            "Prereq": "SPX Prerequisites: (BIOL 3301 and BIOL 3302 and BIOL 3361) or instructor consent required"
        },
        "biol4320": {
            "Prereq": "SPX Prerequisites: (BIOL 3301 and BIOL 3302) and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "biol4325": {
            "Prereq": "(BIOL 3361 and BIOL 3161)  and (BIOL 3362 and BIOL 3162) "
        },
        "biol4330": {
            "Prereq": "BIOL 2281 and BIOL 2311 and BIOL 3302 and CHEM 2125"
        },
        "biol4337": {
            "Prereq": "(BIOL 3301 and BIOL 3302) and (BIOL 3361 or CHEM 3361) and (BIOL 3362 or CHEM 3362)"
        },
        "biol4341": {
            "Prereq": "BIOL 3301 "
        },
        "biol4345": {
            "Prereq": "SPX Prerequisites: CHEM 2323 and CHEM 2325 (Organic Chemistry I and II)"
        },
        "biol4350": {
            "Prereq": "BIOL 3301 or BIOL 3V20"
        },
        "biol4356": {
            "Prereq": "SPX Prerequisites: BIOL 3301 and BIOL 3302 and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "biol4357": {
            "Prereq": "SPX Prerequisites: BIOL 3301 and BIOL 3302 and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "biol4360": {
            "PreOrCoreq": "BIOL 3301"
        },
        "biol4365": {
            "Prereq": "SPX Prerequisite: BIOL 3302 or instructor consent required"
        },
        "biol4366": {
            "Prereq": "BIOL 3302"
        },
        "biol4371": {
            "Prereq": "SPX Prerequisites: BIOL 3301 and (BIOL 3520 or BIOL 3V20) or instructor consent required"
        },
        "biol4380": {
            "PreOrCoreq": "BIOL 3302"
        },
        "biol4385": {
            "Prereq": "SPX Prerequisites: (BIOL 3361 and (BIOL 3455 or BIOL 3456)) or instructor consent required"
        },
        "biol4461": {
            "Prereq": "((MATH 2413 and MATH 2414) or MATH 2417) and (PHYS 1301 or PHYS 2325 ) and (BIOL 3361 or CHEM 3361)"
        },
        "biol4v00": {
            "Prereq": "SPX Prerequisites: (BIOL 3301 and BIOL 3302) and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "biol4v01": {
            "Prereq": "SPX Prerequisites: (BIOL 3301 and BIOL 3302) and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "biol4v40": {
            "Prereq": "SPX Prerequisites: (BIOL 3301 and BIOL 3302) and (BIOL 3361 or CHEM 3361) or equivalent or instructor consent required"
        },
        "bis1100": {
            "Coreq": "UNIV 1010"
        },
        "bis4306": {
            "Prereq": "SPX Prerequisite: Upper-division standing"
        },
        "blaw3301": {
            "Prereq": "BLAW 2301"
        },
        "blaw4310": {
            "Prereq": "BLAW 2301"
        },
        "bmen1208": {
            "PreOrCoreq": "(PHYS 2325 and PHYS 2125) and (MATH 2419 or MATH 2414)"
        },
        "bmen2320": {
            "PreOrCoreq": "MATH 2415 or MATH 2419 "
        },
        "bmen3110": {
            "PreOrCoreq": "BMEN 3310"
        },
        "bmen3120": {
            "Prereq": "RHET 1302"
        },
        "bmen3130": {
            "PreOrCoreq": "BMEN 3330"
        },
        "bmen3150": {
            "Prereq": "RHET 1302"
        },
        "bmen3170": {
            "Prereq": "BMEN 3370"
        },
        "bmen3200": {
            "Coreq": "BMEN 4310"
        },
        "bmen3220": {
            "Prereq": "CS 1324"
        },
        "bmen3302": {
            "Prereq": "BMEN 1208 and ENGR 3300"
        },
        "bmen3310": {
            "Prereq": "BMEN 1208 and ENGR 3300"
        },
        "bmen3315": {
            "Prereq": "(CHEM 1301 or (CHEM 1311 and CHEM 1312)) and (CHEM 2324 or (CHEM 2323 and CHEM 2325)) and (MATH 2415 or MATH 2419 ) and (PHYS 2126 and PHYS 2326)"
        },
        "bmen3318": {
            "PreOrCoreq": "BMEN 1208 and CHEM 1312 and CHEM 1112"
        },
        "bmen3320": {
            "PreOrCoreq": "CS 1324"
        },
        "bmen3325": {
            "Prereq": "BMEN 1208"
        },
        "bmen3330": {
            "Prereq": "BIOL 2311"
        },
        "bmen3331": {
            "PreOrCoreq": "CHEM 2324"
        },
        "bmen3332": {
            "Prereq": "BMEN 3331"
        },
        "bmen3350": {
            "PreOrCoreq": "BMEN 3402 or EE 3302"
        },
        "bmen3360": {
            "PreOrCoreq": "CHEM 1301 or (CHEM 1311 and CHEM 1312) and CHEM 2324 or (CHEM 2323 and CHEM 2325)"
        },
        "bmen3370": {
            "Prereq": "MATH 2420 and (PHYS 2126 and PHYS 2326)"
        },
        "bmen3380": {
            "Prereq": "EE 3302 or BMEN 3402"
        },
        "bmen3399": {
            "Prereq": "BMEN 2320"
        },
        "bmen3402": {
            "Prereq": "ENGR 3300"
        },
        "bmen4110": {
            "Prereq": "RHET 1302"
        },
        "bmen4301": {
            "Prereq": "SPX Prerequisites: RHET 1302 and Junior standing"
        },
        "bmen4310": {
            "Prereq": "ENGR 2300 and MATH 2420"
        },
        "bmen4320": {
            "Prereq": "BMEN 3120 and BMEN 3320"
        },
        "bmen4342": {
            "PreOrCoreq": "BMEN 4310 or EE 4310 or MECH 4310 "
        },
        "bmen4350": {
            "Prereq": "(BMEN 3320 and BMEN 3120) and (BMEN 3330 and BMEN 3130)"
        },
        "bmen4355": {
            "Prereq": "SPX Prerequisites: (BMEN 3399 and ENGR 2300) or (senior status and permission of instructor)"
        },
        "bmen4360": {
            "PreOrCoreq": "BMEN 2320 and (CHEM 1301 or (CHEM 1311 and CHEM 1312)) and (CHEM 2324 or (CHEM 2323 and CHEM 2325))"
        },
        "bmen4370": {
            "Prereq": "SPX Prerequisites: BMEN 3402 and experience with MATLAB Programming"
        },
        "bmen4388": {
            "Prereq": "BMEN 3130 and BMEN 3150 and BMEN 3320 and BMEN 3330 and BMEN 3350 and ECS 3390"
        },
        "bmen4389": {
            "Prereq": "BMEN 4388"
        },
        "bps4305": {
            "Prereq": "(BCOM 1300 or BCOM 3300 or BCOM 3310) and FIN 3320 and ITSS 3300 and OPRE 3310 and (OBHR 3310 or OBHR 3330) and MKT 3300"
        },
        "bps4307": {
            "Prereq": "BCOM 1300 or BCOM 3300 or BCOM 3310"
        },
        "bps4395": {
            "Prereq": "BCOM 4300 or BCOM 4350"
        },
        "ce1337": {
            "Prereq": "CS 1336 "
        },
        "ce2305": {
            "Prereq": "SPX Prerequisite: ALEKS score required or MATH 2312 with a grade of C or better"
        },
        "ce2336": {
            "PreOrCoreq": "(CE 2305 or CS 2305) "
        },
        "ce3120": {
            "Prereq": "RHET 1302"
        },
        "ce3161": {
            "Prereq": "SPX Prerequisite: Junior level standing"
        },
        "ce3201": {
            "PreOrCoreq": "(EE 3301 or CE 3301) and (EE 3320 or CE 3320)"
        },
        "ce3202": {
            "PreOrCoreq": "EE 3310 or CE 3310"
        },
        "ce3301": {
            "Prereq": "MATH 2420 and PHYS 2326"
        },
        "ce3303": {
            "Prereq": "MATH 2420"
        },
        "ce3310": {
            "Prereq": "CE 3301 or EE 3301"
        },
        "ce3311": {
            "Prereq": "CE 3310 or EE 3310"
        },
        "ce3320": {
            "Prereq": "CE 2310 or EE 2310"
        },
        "ce3345": {
            "PreOrCoreq": "(CS 3341 or SE 3341 or ENGR 3341)"
        },
        "ce3354": {
            "PreOrCoreq": "ECS 3390"
        },
        "ce4201": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ce4202": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ce4203": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ce4204": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ce4205": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ce4304": {
            "Prereq": "CE 3320 or EE 3320"
        },
        "ce4337": {
            "Prereq": "((CE 2336 or CS 2336 or CS 2337) or CS 3333) and (CE 2305 or CS 2305) and (CS 2340 or SE 3340 or CE 4304 or EE 4304)"
        },
        "ce4348": {
            "Prereq": "SPX Prerequisites: (CS 2340 or SE 3340 or equivalent), and (CE 3345 or CS 3345 or SE 3345), and a working knowledge of C and UNIX"
        },
        "ce4370": {
            "Prereq": "CE 3320 or EE 3320"
        },
        "ce4388": {
            "Prereq": "SPX Prerequisites: ECS 3390 and one of the following prerequisite sequences: ((CE 3311 or EE 3311) and (CE 3320 or EE 3320) and (CE 3345 or CS 3345 or SE 3345) and (CE 3354 or CS 3354 or SE 3354)) or (ENGR 3300 and EE 3302 and (CE 3311 or EE 3311) and (CE 3320 or EE 3320)) or (ENGR 3300 and EE 3302 and (CE 3345 or CS 3345 or SE 3345))"
        },
        "ce4389": {
            "Prereq": "CE 4388 or EE 4388"
        },
        "ce4390": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) "
        },
        "cgs3325": {
            "Prereq": "PSY 2301 or CGS 2301"
        },
        "cgs3340": {
            "Prereq": "PSY 3392 or PSY 3490"
        },
        "cgs3361": {
            "Prereq": "CGS 2301 or PSY 2301"
        },
        "cgs4314": {
            "Prereq": "SPX Prerequisites: ((MATH 2414 or MATH 2419) and (CS 3341 or SE 3341) and MATH2418) or instructor consent required"
        },
        "cgs4315": {
            "Prereq": "CGS 4314 or CS 4314"
        },
        "cgs4320": {
            "Prereq": "PSY 2301 or PSY 3361"
        },
        "cgs4359": {
            "Prereq": "PSY 2301"
        },
        "cgs4362": {
            "Prereq": "CGS 2301 or PSY 2301"
        },
        "cgs4364": {
            "Prereq": "SPX Prerequisite: (CGS 3361 or PSY 3361) or instructor consent required"
        },
        "cgs4385": {
            "Prereq": "NSC 3361"
        },
        "cgs4386": {
            "Prereq": "PSY 2301"
        },
        "cgs4389": {
            "Prereq": "PSY 2301"
        },
        "chem1111": {
            "Coreq": "CHEM 1311"
        },
        "chem1112": {
            "Coreq": "CHEM 1312"
        },
        "chem1115": {
            "Coreq": "CHEM 1315"
        },
        "chem1116": {
            "Coreq": "CHEM 1316"
        },
        "chem1311": {
            "Coreq": "CHEM 1111"
        },
        "chem1312": {
            "Coreq": "CHEM 1112"
        },
        "chem1315": {
            "Coreq": "CHEM 1115"
        },
        "chem1316": {
            "Coreq": "CHEM 1116"
        },
        "chem2123": {
            "Coreq": "CHEM 2323"
        },
        "chem2125": {
            "Coreq": "CHEM 2325"
        },
        "chem2127": {
            "Coreq": "CHEM 2327"
        },
        "chem2128": {
            "Coreq": "CHEM 2328"
        },
        "chem2130": {
            "Coreq": "SPX Corequisite: CHEM 2330 and instructor consent required"
        },
        "chem2323": {
            "Coreq": "CHEM 2123"
        },
        "chem2324": {
            "Prereq": "SPX Prerequisites: (CHEM 1301 or CHEM 1312 or CHEM 1316) and department consent required"
        },
        "chem2325": {
            "Coreq": "CHEM 2125"
        },
        "chem2327": {
            "Coreq": "CHEM 2127"
        },
        "chem2328": {
            "Coreq": "CHEM 2128"
        },
        "chem2330": {
            "Coreq": "CHEM 2130"
        },
        "chem2401": {
            "Prereq": "CHEM 1112 and CHEM 1312"
        },
        "chem3321": {
            "Prereq": "SPX Prerequisites: CHEM 2325 and (MATH 2415 or MATH 2451 or MATH 3351) or instructor consent required"
        },
        "chem3322": {
            "Prereq": "SPX Prerequisite: (MATH 2415 or MATH 2451 or MATH 3351) or instructor consent required"
        },
        "chem3341": {
            "Prereq": "(CHEM 2323 and CHEM 2325) "
        },
        "chem3361": {
            "Coreq": "BIOL 3161"
        },
        "chem3362": {
            "Coreq": "BIOL 3162"
        },
        "chem3471": {
            "Prereq": "SPX Prerequisite: (CHEM 2125 and CHEM 2401) or instructor consent required"
        },
        "chem3472": {
            "Prereq": "CHEM 2401"
        },
        "chem4335": {
            "Prereq": "SPX Prerequisite: CHEM 3321 or instructor consent required"
        },
        "chem4355": {
            "Prereq": "SPX Prerequisites: CHEM 3321 and (MATH 2451 or MATH 3351) or instructor consent required"
        },
        "chem4381": {
            "Prereq": "SPX Prerequisite: CHEM 2325 or instructor consent required"
        },
        "chem4390": {
            "Prereq": "SPX Prerequisite: at least 3 semester credit hours of undergraduate research (e"
        },
        "chem4399": {
            "Prereq": "SPX Prerequisites: Senior level standing with at least 3 semester credit hours of undergraduate research (e"
        },
        "chem4473": {
            "Prereq": "SPX Prerequisites: (CHEM 3321 and CHEM 3472) or instructor consent required"
        },
        "chin1311": {
            "Prereq": "SPX Prerequisite: Completion of the language placement exam or instructor consent required"
        },
        "chin1312": {
            "Prereq": "SPX Prerequisite: CHIN 1311 or equivalent or instructor consent required"
        },
        "chin2311": {
            "Prereq": "SPX Prerequisite: CHIN 1312 or equivalent or instructor consent required"
        },
        "chin2312": {
            "Prereq": "SPX Prerequisite: CHIN 2311 or equivalent or instructor consent required"
        },
        "chin2350": {
            "Prereq": "SPX Prerequisite: CHIN 1302 or equivalent based on placement exam score or instructor consent required"
        },
        "chin3330": {
            "Prereq": "SPX Prerequisite: CHIN 1302 or equivalent based on placement exam score or instructor consent required"
        },
        "chin3365": {
            "Prereq": "SPX Prerequisite: CHIN 2312 or equivalent or instructor consent required"
        },
        "chin4301": {
            "Prereq": "SPX Prerequisite: CHIN 3365 or equivalent based on placement exam score or instructor consent required"
        },
        "chin4364": {
            "Prereq": "SPX Prerequisite: CHIN 3365 or equivalent based on placement exam score or instructor consent required"
        },
        "cldp3332": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp3336": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp3342": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp3362": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp3365": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp3366": {
            "Prereq": "CLDP 3339 or PSY 3339"
        },
        "cldp3394": {
            "Prereq": "(PSY 2317 or STAT 1342) and PSY 3392"
        },
        "cldp3494": {
            "Prereq": "PSY 2317 or STAT 1342"
        },
        "cldp4308": {
            "Prereq": "SPX Prerequisite: CLDP 3303 or SPAU 3303 or instructor consent required"
        },
        "cldp4344": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "cldp4389": {
            "Prereq": "PSY 2301"
        },
        "comm3320": {
            "Prereq": "SPX Prerequisite: COMM 2314 or THEA 1352 or THEA 2372 or instructor consent required"
        },
        "comm3321": {
            "Prereq": "SPX Prerequisite: (COMM 1311 or COMM 1315 or COMM 2314) or instructor consent required"
        },
        "comm3340": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or equivalent or instructor consent required"
        },
        "comm3342": {
            "Prereq": "RHET 1302"
        },
        "comm3350": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or instructor consent required"
        },
        "comm3351": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or instructor consent required"
        },
        "comm4305": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311 and upper-level standing) or instructor consent required"
        },
        "comm4314": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or instructor consent required"
        },
        "comm4360": {
            "Prereq": "SPX Prerequisites: RHET 1302 and upper-division standing"
        },
        "comm4370": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or instructor consent required"
        },
        "comm4371": {
            "Prereq": "SPX Prerequisite: COMM 1311 or instructor consent required"
        },
        "comm4375": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and COMM 1311) or instructor consent required"
        },
        "comm4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "crim3302": {
            "Prereq": "CRIM 1307"
        },
        "crim3303": {
            "Prereq": "CRIM 1301"
        },
        "crim3326": {
            "Prereq": "CRIM 1301 or CRIM 1307"
        },
        "crim3327": {
            "Prereq": "CRIM 1301 or CRIM 1307"
        },
        "crim4311": {
            "Prereq": "CRIM 3302 or CRIM 3303"
        },
        "crim4315": {
            "Prereq": "CRIM 3302 or CRIM 3303"
        },
        "crim4322": {
            "Prereq": "SPX Prerequisites: EPPS 2301 and EPPS 2302 and Upper-division standing and instructor consent required"
        },
        "crim4323": {
            "Prereq": "CRIM 3302"
        },
        "crwt2301": {
            "Prereq": "RHET 1302"
        },
        "crwt3306": {
            "Prereq": "CRWT 2301"
        },
        "crwt3308": {
            "Prereq": "CRWT 2301"
        },
        "crwt3351": {
            "Prereq": "CRWT 2301"
        },
        "crwt3354": {
            "Prereq": "CRWT 2301"
        },
        "crwt4307": {
            "Prereq": "CRWT 3307"
        },
        "crwt4353": {
            "Prereq": "CRWT 3351"
        },
        "crwt4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "cs1134": {
            "Coreq": "CS 1334"
        },
        "cs1136": {
            "Coreq": "CS 1336"
        },
        "cs1324": {
            "Prereq": "CS 1336 "
        },
        "cs1325": {
            "Prereq": "CS 1336 "
        },
        "cs1334": {
            "Coreq": "CS 1134"
        },
        "cs1335": {
            "Prereq": "CS 1334 "
        },
        "cs1336": {
            "Coreq": "CS 1136"
        },
        "cs1337": {
            "Prereq": "CS 1336 "
        },
        "cs2305": {
            "Prereq": "SPX Prerequisite: ALEKS score required or MATH 2312 with a grade of C or better"
        },
        "cs2335": {
            "Prereq": "CS 1335 or CE 1337 or CS 1337"
        },
        "cs2336": {
            "PreOrCoreq": "(CE 2305 or CS 2305) "
        },
        "cs2337": {
            "PreOrCoreq": "(CE 2305 or CS 2305) "
        },
        "cs3149": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337)  and CS 3305 "
        },
        "cs3162": {
            "PreOrCoreq": "CS 3345 and CS 3354"
        },
        "cs3305": {
            "Prereq": "(CE 2305 or CS 2305)  and (MATH 2414 or MATH 2419)"
        },
        "cs3333": {
            "Prereq": "SPX Prerequisite: CS 1335 or (CE 1337 or CS 1337) or equivalent programming experience"
        },
        "cs3341": {
            "Prereq": "(MATH 1326 or MATH 2414 or MATH 2419) and (CE 2305 or CS 2305) "
        },
        "cs3345": {
            "PreOrCoreq": "(CS 3341 or SE 3341 or ENGR 3341)"
        },
        "cs3354": {
            "PreOrCoreq": "ECS 3390"
        },
        "cs3360": {
            "Prereq": "CS 2335"
        },
        "cs3377": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337) "
        },
        "cs4141": {
            "Coreq": "CS 4341"
        },
        "cs4301": {
            "Prereq": "CE 3345 or CS 3345 or SE 3345"
        },
        "cs4313": {
            "Prereq": "(MATH 2414 or MATH 2419) and (STAT 3341 or STAT 4351) and MATH 2418"
        },
        "cs4314": {
            "Prereq": "SPX Prerequisites: ((MATH 2414 or MATH 2419) and (CS 3341 or SE 3341) and MATH2418) or instructor consent required"
        },
        "cs4315": {
            "Prereq": "SPX Prerequisite: CGS 4314 or CS 4314 or instructor consent required"
        },
        "cs4332": {
            "Prereq": "CE 3345 or CS 3345 or SE 3345"
        },
        "cs4334": {
            "Prereq": "(MATH 2370 or CS 1324 or CS 1325 or CE 1337 or CS 1337) and (MATH 2418 and MATH 2451 or MATH 3351)"
        },
        "cs4336": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337) "
        },
        "cs4337": {
            "Prereq": "((CE 2336 or CS 2336 or CS 2337) or CS 3333) and (CE 2305 or CS 2305) and (CS 2340 or SE 3340 or CE 4304 or EE 4304)"
        },
        "cs4341": {
            "Coreq": "CS 4141"
        },
        "cs4347": {
            "Prereq": "CE 3345 or CS 3345 or SE 3345"
        },
        "cs4348": {
            "Prereq": "(CS 2340 or SE 3340)  and (CS 3377 or SE 3377) and (CE 3345 or CS 3345 or SE 3345)"
        },
        "cs4349": {
            "Prereq": "CS 3305  and (CE 3345 or CS 3345 or SE 3345)"
        },
        "cs4361": {
            "Prereq": "MATH 2418 and (CE 2336 or CS 2336 or CS 2337) and (CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4365": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4371": {
            "Prereq": "(CS 2336 or CS 2337) and CS 4347"
        },
        "cs4372": {
            "Coreq": "CS 4375"
        },
        "cs4375": {
            "Prereq": "(CS 3341 or SE 3341) and (CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4376": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337) "
        },
        "cs4384": {
            "Prereq": "CS 3305 "
        },
        "cs4386": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4389": {
            "Prereq": "CS 4347 or SE 4347"
        },
        "cs4390": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4391": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4392": {
            "Prereq": "MATH 2418 and (CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4393": {
            "Prereq": "(CE 4348 or CS 4348 or SE 4348) "
        },
        "cs4394": {
            "Prereq": "SPX Prerequisite: CE 4348 or CS 4348 or SE 4348 or equivalent programming experience"
        },
        "cs4395": {
            "Prereq": "(CS 3341 or SE 3341) and (CE 3345 or CS 3345 or SE 3345) "
        },
        "cs4396": {
            "Prereq": "CS 4390 "
        },
        "cs4397": {
            "Prereq": "(CE 4348 or CS 4348 or SE 4348) "
        },
        "cs4398": {
            "Prereq": "(CE 4348 or CS 4348 or SE 4348) and (CE 4390 or CS 4390) "
        },
        "cs4475": {
            "Prereq": "STAT 4355 and CS 4375"
        },
        "cs4485": {
            "Prereq": "(CE 3345 or CS 3345 or SE 3345) and (CE 3354 or CS 3354 or SE 3354)  "
        },
        "cs4v95": {
            "Prereq": "SPX Prerequisite: (CE 3345 or CS 3345 or SE 3345) and instructor consent required"
        },
        "danc3332": {
            "Prereq": "SPX Prerequisite: Minimum of 6 semester credit hours in any combination of DANC 2331 or DANC 2332 or DANC 2333 or DANC 2334 or instructor consent required"
        },
        "danc3333": {
            "Prereq": "SPX Prerequisite: Minimum of 6 semester credit hours in any combination of DANC 2332 or DANC 2334 or instructor consent required"
        },
        "danc3334": {
            "Prereq": "SPX Prerequisite: Minimum of 6 semester credit hours in any combination of DANC 2332 or DANC 2333 or DANC 2334 or instructor consent required"
        },
        "danc3335": {
            "Prereq": "SPX Prerequisite: Minimum of 6 semester credit hours in DANC 2334 or instructor consent required"
        },
        "danc3340": {
            "Prereq": "SPX Prerequisite: Completion of 050 core"
        },
        "danc3342": {
            "Prereq": "SPX Prerequisite: Completion of 050 core or instructor consent required"
        },
        "danc3347": {
            "Prereq": "SPX Prerequisite: DANC 3332 or DANC 3333 or DANC 3334 or DANC 3335 or instructor consent required"
        },
        "danc4313": {
            "Prereq": "SPX Prerequisite: DANC 3332 or instructor consent required"
        },
        "danc4314": {
            "Prereq": "SPX Prerequisite: DANC 3333 or DANC 3335 or instructor consent required"
        },
        "danc4315": {
            "Prereq": "SPX Prerequisite: DANC 3335 or instructor consent required"
        },
        "danc4316": {
            "Prereq": "SPX Prerequisite: DANC 3333 or DANC 3334 or DANC 3335 or instructor consent required"
        },
        "danc4318": {
            "Prereq": "SPX Prerequisite: DANC 4313 or DANC 4314 or DANC 4315 or DANC 4316 or instructor consent required"
        },
        "danc4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "econ2001": {
            "Coreq": "ECON 2301"
        },
        "econ3310": {
            "Prereq": "ECON 2302 and (MATH 1325 or MATH 2413 or MATH 2417) and (ENGR 3310 or EPPS 2302 or OPRE 3360 or STAT 1342 or STAT 2332 or STAT 3341 or STAT 3355 or STAT 3360 or STAT 4351)"
        },
        "econ3311": {
            "Prereq": "ECON 2301 and ECON 2302 and (MATH 1325 or MATH 2413 or MATH 2417) and (ENGR 3314 or EPPS 2302 or OPRE 3360 or STAT 1342 or STAT 2332 or STAT 3341 or STAT 3355 or STAT 3360 or STAT 4351)"
        },
        "econ3312": {
            "Prereq": "ECON 3311"
        },
        "econ3315": {
            "Prereq": "ECON 2302"
        },
        "econ3332": {
            "Prereq": "ECON 2301 and ECON 2302 and (EPPS 2302 or STAT 1342)"
        },
        "econ3336": {
            "Prereq": "ECON 2302"
        },
        "econ3337": {
            "Prereq": "ECON 2302"
        },
        "econ3369": {
            "Prereq": "ECON 2302"
        },
        "econ4301": {
            "Prereq": "ECON 3310"
        },
        "econ4302": {
            "Prereq": "ECON 3310"
        },
        "econ4310": {
            "Prereq": "ECON 2302 and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "econ4320": {
            "Prereq": "ECON 3310"
        },
        "econ4332": {
            "Prereq": "ECON 2302 and ECON 3310"
        },
        "econ4333": {
            "Prereq": "ECON 2302 and ECON 3310"
        },
        "econ4334": {
            "Prereq": "ECON 3310"
        },
        "econ4336": {
            "Prereq": "ECON 2302"
        },
        "econ4340": {
            "Prereq": "ECON 3310"
        },
        "econ4342": {
            "Prereq": "ECON 3310"
        },
        "econ4345": {
            "Prereq": "ECON 3310"
        },
        "econ4348": {
            "Prereq": "SPX Prerequisite: ECON 2302 or instructor consent required"
        },
        "econ4351": {
            "Prereq": "(EPPS 2302 or OPRE 3360 or STAT 1342 or STAT 2332 or STAT 3341 or STAT 3355 or STAT 3360 or STAT 4351) and (MATH 1326 or MATH 2414 or MATH 2419)"
        },
        "econ4355": {
            "Prereq": "(EPPS 2302 or OPRE 3360 or STAT 1342 or STAT 2332 or STAT 3341 or STAT 3355 or STAT 3360 or STAT 4351) and (MATH 1326 or MATH 2414 or MATH 2419)"
        },
        "econ4360": {
            "Prereq": "ECON 3310"
        },
        "econ4362": {
            "Prereq": "ECON 2302 and ECON 3311"
        },
        "econ4382": {
            "Prereq": "ECON 3311"
        },
        "econ4385": {
            "Prereq": "(MATH 1326 or MATH 2414 or MATH 2419) and (EPPS 2302 or OPRE 3360 or STAT 1342 or STAT 2332 or STAT 3341 or STAT 3355 or STAT 3360 or STAT 4351)"
        },
        "ecs1100": {
            "Coreq": "UNIV 1010"
        },
        "ecs2361": {
            "Prereq": "SPX Prerequisite: Completion of an 030 core course"
        },
        "ecs3301": {
            "Prereq": "SPX Prerequisites: CHEM 1311 and (MATH 2415 or MATH 2419 or equivalent) and PHYS 2326 or instructor consent required"
        },
        "ecs3310": {
            "Prereq": "SPX Prerequisites: CHEM 1311 and (MATH 2415 or MATH 2419 or equivalent) and PHYS 2326 or instructor consent required"
        },
        "ecs3390": {
            "Prereq": "SPX Prerequisites: RHET 1302 and junior standing"
        },
        "ecsc4378": {
            "PreOrCoreq": "SPX Prerequisites or Corequisites: ECS 3390 and instructor consent required"
        },
        "ed3314": {
            "Prereq": "SPX Prerequisite: Completion of 45 semester credit hours of course work"
        },
        "ed3315": {
            "Prereq": "HUMA 1301 "
        },
        "ed3340": {
            "Prereq": "MATH 1306 or MATH 1314"
        },
        "ed4357": {
            "Prereq": "SPX Prerequisites: ED 4352 and ED 4363 and department consent required"
        },
        "ed4363": {
            "Prereq": "SPX Prerequisite: ED 4352 and department consent required"
        },
        "ee3120": {
            "Prereq": "RHET 1302"
        },
        "ee3161": {
            "Prereq": "SPX Prerequisite: Junior level standing"
        },
        "ee3201": {
            "PreOrCoreq": "(EE 3301 or CE 3301) and (EE 3320 or CE 3320)"
        },
        "ee3202": {
            "PreOrCoreq": "EE 3310 or CE 3310"
        },
        "ee3301": {
            "Prereq": "MATH 2420 and PHYS 2326"
        },
        "ee3302": {
            "Prereq": "ENGR 3300"
        },
        "ee3310": {
            "Prereq": "CE 3301 or EE 3301"
        },
        "ee3311": {
            "Prereq": "CE 3310 or EE 3310"
        },
        "ee3320": {
            "Prereq": "CE 2310 or EE 2310"
        },
        "ee3350": {
            "Prereq": "ENGR 3300 and (CE 3301 or EE 3301) and EE 3302 and ENGR 3341"
        },
        "ee4168": {
            "PreOrCoreq": "EE 4368"
        },
        "ee4201": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ee4202": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ee4203": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ee4204": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ee4205": {
            "Prereq": "SPX Prerequisite: CE 3202 or EE 3202 or instructor consent required"
        },
        "ee4301": {
            "Prereq": "PHYS 2326 and ENGR 3300 and (CE 3301 or EE 3301)"
        },
        "ee4304": {
            "Prereq": "CE 3320 or EE 3320"
        },
        "ee4310": {
            "Prereq": "ENGR 2300 and EE 3302"
        },
        "ee4325": {
            "Prereq": "SPX Prerequisite: CE 3320 or EE 3320 (or, for CS majors, CS 4341)"
        },
        "ee4330": {
            "Prereq": "CE 3310 or EE 3310"
        },
        "ee4331": {
            "Prereq": "MATH 2419 and ENGR 2300 and ENGR 3341"
        },
        "ee4340": {
            "Prereq": "CE 3311 or EE 3311"
        },
        "ee4342": {
            "PreOrCoreq": "BMEN 4310 or EE 4310 or MECH 4310 "
        },
        "ee4360": {
            "Prereq": "ENGR 3341 and EE 3302"
        },
        "ee4361": {
            "Prereq": "EE 3302"
        },
        "ee4362": {
            "Prereq": "EE 3301"
        },
        "ee4365": {
            "Prereq": "EE 3302 and ENGR 3341"
        },
        "ee4367": {
            "PreOrCoreq": "EE 3350"
        },
        "ee4368": {
            "Prereq": "(CE 3310 or EE 3310) and EE 4301"
        },
        "ee4370": {
            "Prereq": "CE 3320 or EE 3320"
        },
        "ee4371": {
            "Prereq": "CHEM 1311 and (MECH 3310 and MECH 3350 and PHYS 2126 and PHYS 2326) or ((CE 3310 or EE 3310) and PHYS 2125 and PHYS 2325)"
        },
        "ee4388": {
            "Prereq": "SPX Prerequisites: ECS 3390 and one of the following prerequisite sequences: ((CE 3311 or EE 3311) and (CE 3320 or EE 3320) and (CE 3345 or CS 3345 or SE 3345) and (CE 3354 or CS 3354 or SE 3354)) or (ENGR 3300 and EE 3302 and (CE 3311 or EE 3311) and (CE 3320 or EE 3320)) or (ENGR 3300 and EE 3302 and (CE 3345 or CS 3345 or SE 3345))"
        },
        "ee4389": {
            "Prereq": "CE 4388 or EE 4388"
        },
        "ee4391": {
            "Prereq": "ENGR 3300 and (CE 3310 or EE 3310)"
        },
        "engr2300": {
            "PreOrCoreq": "MATH 2414 or MATH 2419"
        },
        "engr3300": {
            "PreOrCoreq": "MATH 2420"
        },
        "engr3341": {
            "Prereq": "MATH 2414 or MATH 2419"
        },
        "engy3330": {
            "Prereq": "ECON 2302"
        },
        "engy4300": {
            "Prereq": "OPRE 3310"
        },
        "engy4313": {
            "Prereq": "FIN 3320"
        },
        "entp3360": {
            "Prereq": "FIN 3320"
        },
        "entp4311": {
            "Prereq": "SPX Prerequisites: (ENTP 3301 or instructor consent required) and sophomore standing"
        },
        "entp4320": {
            "Prereq": "SPX Prerequisite: ENTP 3301 or instructor consent required"
        },
        "entp4330": {
            "Prereq": "SPX Prerequisites: ENTP 3301 or instructor consent required"
        },
        "entp4335": {
            "Prereq": "MKT 3300"
        },
        "entp4340": {
            "Prereq": "SPX Prerequisite: At least Junior Level standing"
        },
        "entp4350": {
            "Prereq": "SPX Prerequisites: (ENTP 3301 or instructor consent required), and at least junior standing"
        },
        "entp4395": {
            "Prereq": "SPX Prerequisites: Junior or senior standing and instructor consent"
        },
        "epcs3100": {
            "Prereq": "EPCS 2100"
        },
        "epcs3200": {
            "Prereq": "EPCS 2100 or EPCS 2200"
        },
        "epps1110": {
            "Coreq": "UNIV 1010"
        },
        "epps2302": {
            "Prereq": "MATH 1314 "
        },
        "film3321": {
            "Prereq": "SPX Prerequisite: FILM 2332 or instructor consent required"
        },
        "film3325": {
            "Prereq": "SPX Prerequisite: FILM 2332 or instructor consent required"
        },
        "film3342": {
            "Prereq": "SPX Prerequisite: FILM 2332 or instructor consent required"
        },
        "film4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "fin3100": {
            "Prereq": "BA 1100"
        },
        "fin3320": {
            "PreOrCoreq": "ACCT 2301 and (STAT 3360 or OPRE 3360)"
        },
        "fin3330": {
            "PreOrCoreq": "OPRE 3360 or STAT 3360 or STAT 4351"
        },
        "fin3340": {
            "PreOrCoreq": "FIN 3320"
        },
        "fin3350": {
            "Prereq": "ECON 2301"
        },
        "fin3360": {
            "Prereq": "FIN 3320"
        },
        "fin3365": {
            "Prereq": "FIN 3320"
        },
        "fin3370": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "fin3375": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin3380": {
            "Prereq": "FIN 3320"
        },
        "fin3390": {
            "Prereq": "FIN 3320 and ITSS 3300 and (MATH 2333 or MATH 2418 or CS 2305 or OPRE 3333) and (OPRE 3360 or STAT 3360 or STAT 4351) and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340)"
        },
        "fin4300": {
            "PreOrCoreq": "FIN 3390"
        },
        "fin4303": {
            "Prereq": "SPX Prerequisites: FIN 3320 and (FIN 4300 or Instructor consent required)"
        },
        "fin4305": {
            "Prereq": "FIN 3320"
        },
        "fin4307": {
            "Prereq": "SPX Prerequisites: FIN 3320 and (FIN 4300 or Instructor consent required)"
        },
        "fin4310": {
            "PreOrCoreq": "FIN 3390"
        },
        "fin4313": {
            "Prereq": "FIN 3320"
        },
        "fin4315": {
            "Prereq": "FIN 3320"
        },
        "fin4320": {
            "Prereq": "FIN 3320"
        },
        "fin4321": {
            "PreOrCoreq": "FIN 3305 or REAL 3305"
        },
        "fin4328": {
            "Prereq": "((REAL 3305 or FIN 3305) or (REAL 3365 or FIN 3365)) and FIN 3320"
        },
        "fin4330": {
            "Prereq": "FIN 3320 or FIN 3330"
        },
        "fin4331": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin4332": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin4333": {
            "PreOrCoreq": "RMIS 4331 or RMIS 4332"
        },
        "fin4334": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin4335": {
            "Prereq": "FIN 3330"
        },
        "fin4336": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin4337": {
            "Prereq": "(ACCT 3331 ) and FIN 3320"
        },
        "fin4338": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "fin4340": {
            "Prereq": "FIN 4300 or FIN 4310"
        },
        "fin4345": {
            "Prereq": "FIN 3390"
        },
        "fin4350": {
            "PreOrCoreq": "SPX Prerequisite or Corequisite: FIN 3370 or instructor consent required"
        },
        "fin4380": {
            "Prereq": "SPX Prerequisites: FIN 4300 and Department consent required"
        },
        "fin4386": {
            "Prereq": "SPX Prerequisites: (STAT 4351 and FIN 4340) or instructor consent required"
        },
        "fin4387": {
            "Prereq": "SPX Prerequisites: STAT 4352 and (FIN 4386 or FIN 4340), or instructor consent required"
        },
        "fin4395": {
            "Prereq": "SPX Prerequisites: (BCOM 4300 or BCOM 4350) and Junior or Senior standing"
        },
        "fin4v90": {
            "Prereq": "SPX Prerequisites: (FIN 4300 or FIN 4310) and faculty sponsor approval"
        },
        "fren1311": {
            "Prereq": "SPX Prerequisites: Completion of the language placement exam or instructor consent required"
        },
        "fren1312": {
            "Prereq": "SPX Prerequisite: FREN 1311 or equivalent or department consent required"
        },
        "fren2311": {
            "Prereq": "SPX Prerequisite: FREN 1312 or equivalent or department consent required"
        },
        "fren2312": {
            "Prereq": "SPX Prerequisite: FREN 2311 or equivalent or department consent required"
        },
        "geos1103": {
            "PreOrCoreq": "GEOS 1303"
        },
        "geos1104": {
            "PreOrCoreq": "GEOS 1304"
        },
        "geos1304": {
            "Prereq": "GEOS 1303 and GEOS 1103"
        },
        "geos2306": {
            "Prereq": "GEOS 1103 and GEOS 1303"
        },
        "geos2409": {
            "PreOrCoreq": "GEOS 1103 and GEOS 1303"
        },
        "geos3300": {
            "Prereq": "GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2306"
        },
        "geos3421": {
            "Prereq": "GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409"
        },
        "geos3434": {
            "Prereq": "GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409"
        },
        "geos3464": {
            "Prereq": "CHEM 1111 and CHEM 1112 and CHEM 1311 and CHEM 1312 and GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409"
        },
        "geos3470": {
            "Prereq": "GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409 and PHYS 2125 and PHYS 2126 and PHYS 2325 and PHYS 2326"
        },
        "geos4300": {
            "Prereq": "GEOS 3300 and GEOS 3421 and GEOS 3464 and GEOS 3470"
        },
        "geos4320": {
            "Prereq": "CHEM 1111 and CHEM 1112 and CHEM 1311 and CHEM 1312 and GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409 and PHYS 2125 and PHYS 2126 and PHYS 2325 and PHYS 2326"
        },
        "geos4322": {
            "Prereq": "CHEM 1111 and CHEM 1112 and CHEM 1311 and CHEM 1312 and GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409"
        },
        "geos4390": {
            "Prereq": "SPX Prerequisites: Instructor consent required and senior level standing in Geosciences"
        },
        "geos4430": {
            "Prereq": "CHEM 1111 and CHEM 1112 and CHEM 1311 and CHEM 1312 and GEOS 1103 and GEOS 1104 and GEOS 1303 and GEOS 1304 and GEOS 2409"
        },
        "germ1311": {
            "Prereq": "SPX Prerequisites: Completion of the language placement exam or instructor consent required"
        },
        "germ1312": {
            "Prereq": "SPX Prerequisite: GERM 1311 or equivalent or department consent required"
        },
        "germ2311": {
            "Prereq": "SPX Prerequisite: GERM 1312 or equivalent or department consent required"
        },
        "germ2312": {
            "Prereq": "SPX Prerequisite: GERM 2311 or equivalent or department consent required"
        },
        "germ2350": {
            "Prereq": "GERM 1312"
        },
        "gisc4317": {
            "Prereq": "GEOG 3304 or GEOS 3304 or GISC 3304"
        },
        "gisc4326": {
            "Prereq": "GEOS 2305 or GISC 2305 or GEOG 3304 or GEOS 3304 or GISC 3304"
        },
        "gisc4382": {
            "Prereq": "SPX Prerequisite: GEOG 3304 or GEOS 3304 or GISC 3304 or equivalent with instructor consent required"
        },
        "gisc4385": {
            "Prereq": "GEOS 2305 or GISC 2305 or GEOG 3304 or GEOS 3304 or GISC 3304"
        },
        "govt2107": {
            "Prereq": "GOVT 2305 and GOVT 2306"
        },
        "hist3301": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3305": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3306": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3312": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3313": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3314": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3319": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3320": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3324": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3327": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course and department consent required"
        },
        "hist3328": {
            "Prereq": "SPX Prerequisite: Upper-division standing or any previous PHIL course or completion of a 060 core course or instructor consent required"
        },
        "hist3337": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3340": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3341": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3344": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3346": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3364": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3365": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3366": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3368": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3369": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3374": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3376": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3377": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3379": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3380": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3382": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3386": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3387": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3389": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3390": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3391": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3396": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3398": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist3399": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4344": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4347": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4349": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4357": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4358": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4359": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4360": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4369": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4376": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4377": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4378": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4379": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4380": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4381": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4382": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4383": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4384": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4385": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4386": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4387": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4388": {
            "Prereq": "SPX Prerequisite: Completion of a 060 core course"
        },
        "hist4390": {
            "Coreq": "SPX Corequisite: A 4000-level HIST course"
        },
        "hist4v71": {
            "Prereq": "SPX Prerequisites: Completion of a 060 core course and upper-division standing and instructor consent required"
        },
        "hlth3300": {
            "Prereq": "SPX Prerequisites: Must be at least a sophomore and instructor consent required"
        },
        "hlth4380": {
            "Prereq": "SPX Prerequisite: Upper-division standing or instructor or Associate Dean consent required"
        },
        "hmgt3100": {
            "Prereq": "BA 1100"
        },
        "hmgt3301": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "hmgt3310": {
            "Prereq": "HMGT 3301"
        },
        "hmgt3311": {
            "Prereq": "ACCT 2301"
        },
        "hmgt4321": {
            "Prereq": "HMGT 3301 and ITSS 3300"
        },
        "hmgt4331": {
            "Prereq": "HMGT 3301 and MKT 3300"
        },
        "hmgt4392": {
            "Prereq": "HMGT 3301 and OPRE 3310"
        },
        "hmgt4395": {
            "Prereq": "(BCOM 4300 or BCOM 4350) and HMGT 3301 and HMGT 3310 and HMGT 3311 and HMGT 4321"
        },
        "hons3101": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3104": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3108": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3110": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3111": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3112": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3113": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3114": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "hons3199": {
            "Prereq": "SPX Prerequisite: CV Honors students only"
        },
        "huma3342": {
            "Prereq": "SPX Prerequisite: Completion of 040 core"
        },
        "huma4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "ims3100": {
            "Prereq": "BA 1100"
        },
        "ims3310": {
            "Prereq": "BA 1310 or BA 1320 or ECON 2301"
        },
        "ims4310": {
            "Prereq": "IMS 3310 and BLAW 4301"
        },
        "ims4320": {
            "Prereq": "IMS 3310 and MKT 3300"
        },
        "ims4325": {
            "Prereq": "IMS 3310 and MKT 3300"
        },
        "ims4330": {
            "Prereq": "(OBHR 3310 or OBHR 3330) and IMS 3310"
        },
        "ims4332": {
            "Prereq": "OBHR 4352 and IMS 4330"
        },
        "ims4334": {
            "Prereq": "OBHR 4350 and IMS 4330"
        },
        "ims4335": {
            "Prereq": "SPX Prerequisite: At least Junior Level standing"
        },
        "ims4373": {
            "Prereq": "IMS 3310 and IMS 4320 and FIN 3380"
        },
        "ims4395": {
            "Prereq": "SPX Prerequisites: (BCOM 4300 or BCOM 4350) and IMS 4373 and Junior or senior standing"
        },
        "isah2188": {
            "Prereq": "SPX Prerequisites: Student is a member of the A&H LLC and department consent required"
        },
        "isec4102": {
            "Coreq": "ISEC 4201"
        },
        "isec4201": {
            "Coreq": "ISEC 4102"
        },
        "isis3v70": {
            "Prereq": "SPX Prerequisites: Must have completed the relevant course with a grade of at least B and have a UT Dallas grade point average of at least 3"
        },
        "itss3100": {
            "Prereq": "BA 1100"
        },
        "itss3312": {
            "Prereq": "ITSS 3311 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2333 or MATH 2418 or OPRE 3333)"
        },
        "itss4300": {
            "Prereq": "ITSS 3300 and ITSS 3311 and (MATH 1325 or MATH 2413 or MATH 2417) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4301": {
            "Prereq": "(ACCT 2302 ) and ITSS 3300 and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "itss4312": {
            "Prereq": "ITSS 3312"
        },
        "itss4320": {
            "Prereq": "HMGT 3301 and ITSS 3300"
        },
        "itss4330": {
            "PreOrCoreq": "ITSS 4300"
        },
        "itss4340": {
            "Prereq": "ITSS 3300 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4342": {
            "PreOrCoreq": "ACCT 3332"
        },
        "itss4343": {
            "Prereq": "ITSS 3300"
        },
        "itss4351": {
            "Prereq": "ITSS 3300 and ITSS 4300 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4352": {
            "Prereq": "ITSS 3300 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4353": {
            "Prereq": "ITSS 3312 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4354": {
            "Prereq": "ITSS 3312 and ITSS 4300 and ITSS 4351"
        },
        "itss4355": {
            "Prereq": "ITSS 3312 and ITSS 4300 and ITSS 4351"
        },
        "itss4360": {
            "Prereq": "ITSS 3300 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "itss4361": {
            "Prereq": "ITSS 4360"
        },
        "itss4362": {
            "Prereq": "ITSS 4360"
        },
        "itss4370": {
            "Prereq": "ITSS 3300 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2333 or MATH 2418 or OPRE 3333) and ITSS 4330"
        },
        "itss4380": {
            "Prereq": "ITSS 4300"
        },
        "itss4381": {
            "Prereq": "ITSS 3311"
        },
        "itss4395": {
            "Prereq": "(BCOM 4300 or BCOM 4350) and ITSS 4330 and (CS 2305 or MATH 2333 or MATH 2418 or OPRE 3333) and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340)"
        },
        "japn1312": {
            "Prereq": "SPX Prerequisite: JAPN 1311 or equivalent or instructor consent required"
        },
        "japn2311": {
            "Prereq": "SPX Prerequisite: JAPN 1312 or equivalent or instructor consent required"
        },
        "japn2312": {
            "Prereq": "SPX Prerequisite: JAPN 2311 or equivalent or instructor consent required"
        },
        "japn2350": {
            "Prereq": "JAPN 1312"
        },
        "japn3311": {
            "Prereq": "SPX Prerequisite: JAPN 2312 or equivalent or instructor consent required"
        },
        "japn4301": {
            "Prereq": "SPX Prerequisite: JAPN 3311 or equivalent based on placement exam score or instructor consent required"
        },
        "japn4364": {
            "Prereq": "SPX Prerequisite: JAPN 3311 or equivalent based on placement exam score or instructor consent required"
        },
        "lang1312": {
            "Prereq": "SPX Prerequisite: LANG 1311 or equivalent or instructor consent required"
        },
        "lang2312": {
            "Prereq": "SPX Prerequisite: LANG 2311 or equivalent or instructor consent required"
        },
        "lang3348": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "lang4v71": {
            "Prereq": "SPX Prerequisite: Upper-division standing and instructor consent required"
        },
        "lats3301": {
            "Prereq": "SPX Prerequisites: (Latin American Studies major or minor) and completion of 040 core"
        },
        "lats3302": {
            "Prereq": "SPX Prerequisite: Latin American Studies major or minor"
        },
        "lit3300": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3309": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3310": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3312": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3314": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3316": {
            "Prereq": "SPX Prerequisite: Completion of 040 core or instructor consent required"
        },
        "lit3317": {
            "Prereq": "SPX Prerequisite: Completion of 040 core or instructor consent required"
        },
        "lit3319": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3320": {
            "Prereq": "SPX Prerequisite: Completion of 040 core or instructor consent required"
        },
        "lit3328": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3330": {
            "Prereq": "SPX Prerequisite: Completion of 040 core or instructor consent required"
        },
        "lit3332": {
            "Prereq": "SPX Prerequisite: Completion of 040 core or instructor consent required"
        },
        "lit3334": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3337": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit3338": {
            "Prereq": "SPX Prerequisite: LIT 2350 or equivalent or any previous PHIL course or instructor consent required"
        },
        "lit3339": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and LIT 2350) or equivalent or instructor consent required"
        },
        "lit4329": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit4348": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent or instructor consent required"
        },
        "lit4390": {
            "Prereq": "SPX Prerequisites: (LIT 2350 and 6 semester credit hours from the following: LIT 2320 or LIT 2321 or LIT 2331) or equivalent and 90 semester credit hours or instructor consent required"
        },
        "lit4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "lit4v99": {
            "Prereq": "SPX Prerequisite: Upper-division standing and instructor consent required"
        },
        "math1306": {
            "Prereq": "SPX Prerequisite: ALEKS score required"
        },
        "math1314": {
            "Prereq": "SPX Prerequisite: ALEKS score required"
        },
        "math1316": {
            "Prereq": "SPX Prerequisite: ALEKS score required or a grade of at least a C- in MATH 1314 or concurrent enrollment in MATH 1314"
        },
        "math1325": {
            "Prereq": "SPX Prerequisite: ALEKS score required or a grade of at least a C- in MATH 1314"
        },
        "math1326": {
            "Prereq": " MATH 1325"
        },
        "math2306": {
            "Prereq": "SPX Prerequisite: ALEKS score required or a grade of at least a C- in MATH 1314 and MATH 1316"
        },
        "math2312": {
            "Prereq": "SPX Prerequisite: ALEKS score required or (a grade of at least a C- in MATH 1314 and MATH 1316)"
        },
        "math2333": {
            "Prereq": "MATH 1314 "
        },
        "math2399": {
            "Prereq": "SPX Prerequisites: Sophomore level standing in Mathematics and instructor consent required"
        },
        "math2413": {
            "Prereq": "SPX Prerequisite: ALEKS score required or a grade of at least a C- in MATH 2306 or MATH 2312"
        },
        "math2414": {
            "Prereq": " MATH 2417 or  MATH 2413 "
        },
        "math2415": {
            "Prereq": "SPX Prerequisite: A grade of C- or better in MATH 2414"
        },
        "math2417": {
            "Prereq": "SPX Prerequisite: ALEKS score required or a grade of at least a C- in MATH 2306 or MATH 2312"
        },
        "math2418": {
            "Prereq": "  MATH 2306 or MATH 2413 or MATH 2417"
        },
        "math2419": {
            "Prereq": " MATH 2417"
        },
        "math2420": {
            "Prereq": "  MATH 2415 or  MATH 2419  and MATH 2418 "
        },
        "math2451": {
            "Prereq": "  MATH 2415 or  MATH 2419  and MATH 2418 "
        },
        "math3301": {
            "Prereq": "MATH 1306 or MATH 1314 "
        },
        "math3303": {
            "Prereq": "MATH 2418 and  MATH 2415 or  MATH 2419 "
        },
        "math3305": {
            "Prereq": "MATH 2312 or MATH 3301 "
        },
        "math3307": {
            "Prereq": "MATH 2312 and (MATH 3305 or MATH 3321)"
        },
        "math3310": {
            "Prereq": "  MATH 2415 or  MATH 2419 "
        },
        "math3311": {
            "Prereq": "SPX Prerequisites: A grade of at least a C- in either MATH 2415 or in MATH 2419 or equivalent and a grade of at least C- in MATH 2418 or equivalent"
        },
        "math3312": {
            "Prereq": "MATH 3311"
        },
        "math3315": {
            "Prereq": "SPX Prerequisite: (MATH 2417 or equivalent) or instructor consent required"
        },
        "math3321": {
            "Prereq": "  MATH 2306 or MATH 2415 or MATH 2419 "
        },
        "math3323": {
            "Prereq": "  MATH 2414 or  MATH 2418 or MATH 2419"
        },
        "math3351": {
            "Prereq": "(  MATH 2415 or MATH 2419 ) and MATH 2418 "
        },
        "math3379": {
            "Prereq": "(MATH 2451 or MATH 3351) and MATH 3310"
        },
        "math3380": {
            "Prereq": "SPX Prerequisites: (MATH 2451 or MATH 3351) and MATH 2418 and MATH 2420 or equivalent courses"
        },
        "math3397": {
            "Prereq": "MATH 2413 or MATH 2417 or MATH 3321"
        },
        "math4301": {
            "Prereq": "(MATH 2451 or MATH 3351) and MATH 3310"
        },
        "math4302": {
            "Prereq": "MATH 4301"
        },
        "math4332": {
            "Prereq": "SPX Prerequisites: A grade of at least a C- in either MATH 2415 or in MATH 2419 or equivalent and a grade of at least C- in MATH 2418 or equivalent"
        },
        "math4334": {
            "Prereq": "SPX Prerequisites: (MATH 2370 or CS 1324 or CS 1325 or CE 1337 or CS 1337) and (MATH 2418 and (MATH 2451 or MATH 3351)"
        },
        "math4341": {
            "Prereq": "(MATH 2451 or MATH 3351) and MATH 3310"
        },
        "math4355": {
            "Prereq": "SPX Prerequisites: MATH 2418 and MATH 2420 or instructor consent required"
        },
        "math4362": {
            "Prereq": "MATH 2420 and (MATH 2451 or MATH 3351)"
        },
        "math4381": {
            "Prereq": " MATH 2418 "
        },
        "math4390": {
            "Prereq": "SPX Prerequisite: Senior level standing in Mathematics and instructor consent required"
        },
        "math4475": {
            "Prereq": "STAT 4355 and CS 4375"
        },
        "mech1208": {
            "PreOrCoreq": "(PHYS 2325 and PHYS 2125) and (MATH 2419 or MATH 2414)"
        },
        "mech2120": {
            "Coreq": "MECH 2320"
        },
        "mech2310": {
            "PreOrCoreq": "MATH 2415 or MATH 2419 "
        },
        "mech2320": {
            "Coreq": "MECH 2120"
        },
        "mech2330": {
            "PreOrCoreq": "ENGR 2300 and MATH 2420"
        },
        "mech2340": {
            "Prereq": "MATH 2420 and PHYS 2326 and MECH 1208"
        },
        "mech3105": {
            "Coreq": "MECH 3305"
        },
        "mech3115": {
            "Prereq": "MECH 3315"
        },
        "mech3120": {
            "Prereq": "MECH 3320"
        },
        "mech3150": {
            "Prereq": "MECH 3350"
        },
        "mech3305": {
            "Coreq": "MECH 3105"
        },
        "mech3310": {
            "PreOrCoreq": "CHEM 1311"
        },
        "mech3315": {
            "PreOrCoreq": "MECH 3310"
        },
        "mech3320": {
            "Prereq": "MECH 3310 and MECH 3315"
        },
        "mech3340": {
            "Prereq": "MECH 3315"
        },
        "mech3350": {
            "Prereq": "ENGR 2300 and MATH 2420 and MECH 2330 and ENGR 3300"
        },
        "mech3351": {
            "PreOrCoreq": "MECH 3350"
        },
        "mech3360": {
            "Prereq": "SPX Prerequisites: CHEM 1311 and (MATH 2415 or MATH 2419 or equivalent) and PHYS 2326 or instructor consent required"
        },
        "mech3370": {
            "Prereq": "MECH 3310 and MECH 3315"
        },
        "mech3380": {
            "Prereq": "SPX Prerequisites: CS 1325 and MATH 2420 and MECH 2320 and MECH 3305 or equivalents"
        },
        "mech3381": {
            "PreOrCoreq": "MECH 3305"
        },
        "mech4110": {
            "Coreq": "MECH 4310"
        },
        "mech4301": {
            "Prereq": "MECH 2320 and ENGR 3300"
        },
        "mech4310": {
            "Coreq": "MECH 4110"
        },
        "mech4320": {
            "Prereq": "MECH 3320"
        },
        "mech4330": {
            "Prereq": "MECH 3315"
        },
        "mech4340": {
            "Prereq": "ENGR 2300 and MATH 2420 and ENGR 3341 and MECH 2330"
        },
        "mech4342": {
            "PreOrCoreq": "BMEN 4310 or EE 4310 or MECH 4310 "
        },
        "mech4360": {
            "Prereq": "MECH 2320 and MECH 3310"
        },
        "mech4370": {
            "Prereq": "CHEM 1311 and (MECH 3310 and MECH 3350 and PHYS 2126 and PHYS 2326) or ((CE 3310 or EE 3310) and PHYS 2125 and PHYS 2325)"
        },
        "mech4380": {
            "Prereq": "MECH 3320"
        },
        "mech4381": {
            "Prereq": "MECH 3305 and MECH 3320 and MECH 3351 and MECH 3340 and ECS 3390"
        },
        "mech4382": {
            "Prereq": "MECH 4381"
        },
        "meco3330": {
            "Prereq": "ECON 2302"
        },
        "meco4300": {
            "Prereq": "OPRE 3310"
        },
        "meco4315": {
            "Prereq": "FIN 3320"
        },
        "meco4340": {
            "Prereq": "SPX Prerequisite: OPRE 3360 or STAT 3360 or instructor consent required"
        },
        "meco4342": {
            "Prereq": "ECON 2302"
        },
        "meco4351": {
            "Prereq": "ECON 3310"
        },
        "meco4352": {
            "Prereq": "STAT 3360 or OPRE 3360"
        },
        "meco4370": {
            "Prereq": "SPX Prerequisite: OPRE 3360 or STAT 3360 or instructor consent required"
        },
        "mkt3100": {
            "Prereq": "BA 1100"
        },
        "mkt3320": {
            "Prereq": "MKT 3300"
        },
        "mkt3330": {
            "Prereq": "SPX Prerequisite: A minimum of 45 semester credit hours completed"
        },
        "mkt3331": {
            "Prereq": "MKT 3330"
        },
        "mkt3340": {
            "Prereq": "MKT 3300 and (STAT 3360 or OPRE 3360)"
        },
        "mkt3v92": {
            "Prereq": "SPX Prerequisites: MKT 3300 and instructor consent required"
        },
        "mkt4320": {
            "Prereq": "IMS 3310 and MKT 3300"
        },
        "mkt4330": {
            "Prereq": "MKT 3300"
        },
        "mkt4332": {
            "Prereq": "SPX Prerequisites: MKT 3330 and (3"
        },
        "mkt4333": {
            "Prereq": "MKT 3300 and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "mkt4334": {
            "Prereq": "MKT 3300"
        },
        "mkt4335": {
            "Prereq": "MKT 3300 and MKT 3330"
        },
        "mkt4336": {
            "Prereq": "MKT 4330"
        },
        "mkt4337": {
            "Prereq": "MKT 3300"
        },
        "mkt4338": {
            "Prereq": "MKT 3300"
        },
        "mkt4339": {
            "Prereq": "MKT 3300"
        },
        "mkt4340": {
            "Prereq": "MKT 3300 and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "mkt4341": {
            "Prereq": "OPRE 3360 or STAT 3360"
        },
        "mkt4350": {
            "Prereq": "MKT 3300"
        },
        "mkt4360": {
            "Prereq": "MKT 3300"
        },
        "mkt4370": {
            "Prereq": "MKT 3300"
        },
        "mkt4390": {
            "Prereq": "MKT 3300 and MKT 4337 and (OPRE 3360 or STAT 3360)"
        },
        "mkt4395": {
            "PreOrCoreq": "FIN 3320 and MKT 3340"
        },
        "msen3301": {
            "Prereq": "CHEM 1311 and (MATH 2415 or MATH 2419 ) and (PHYS 2326 or PHYS 3342)"
        },
        "msen3302": {
            "Prereq": "CHEM 1311 and (MATH 2415 or MATH 2419 ) and PHYS 2326"
        },
        "msen3304": {
            "Prereq": "CHEM 1312 and (MATH 2415 or MATH 2419 ) and (PHYS 2326 or PHYS 3342)"
        },
        "msen3310": {
            "Prereq": "SPX Prerequisites: CHEM 1311 and (MATH 2415 or MATH 2419 or equivalent) and PHYS 2326 or instructor consent required"
        },
        "msen4391": {
            "Prereq": "ENGR 3300 and (CE 3310 or EE 3310)"
        },
        "msen4v95": {
            "PreOrCoreq": "SPX Prerequisites or Corequisites: MSEN 3301 and MSEN 3302 and instructor consent required"
        },
        "musi2129": {
            "Coreq": "SPX Corequisite: Concurrent enrollment in an ensemble is required"
        },
        "musi2329": {
            "Prereq": "SPX Prerequisite: MUSI 2328 or equivalent or instructor consent required"
        },
        "musi2330": {
            "Prereq": "SPX Prerequisite: MUSI 2329 or equivalent or instructor consent required"
        },
        "musi3118": {
            "Prereq": "SPX Prerequisites: Previous experience playing a string instrument and instructor consent required"
        },
        "musi3120": {
            "Prereq": "SPX Prerequisites: Previous experience playing a wind instrument and instructor consent required"
        },
        "musi3122": {
            "Prereq": "SPX Prerequisites: Previous experience playing a brass instrument and instructor consent required"
        },
        "musi3130": {
            "Prereq": "SPX Prerequisites: Previous experience playing a percussion instrument and instructor consent required"
        },
        "musi3131": {
            "Prereq": "SPX Prerequisites: Previous drumline experience, either battery or front ensemble, and instructor consent required"
        },
        "musi3181": {
            "Prereq": "SPX Prerequisites: Previous experience playing an instrument and instructor consent required"
        },
        "musi3186": {
            "Prereq": "SPX Prerequisites: Previous experience playing an instrument and instructor consent required"
        },
        "musi3229": {
            "Prereq": "SPX Prerequisites: Four semesters of Applied Music study for the principal instrument, or the equivalent, and approval of the music faculty, and instructor consent required"
        },
        "musi3322": {
            "Prereq": "SPX Prerequisite: Completion of 050 Creative Arts Core"
        },
        "musi3324": {
            "Prereq": "SPX Prerequisite: Completion of 050 Creative Arts Core"
        },
        "musi3325": {
            "Prereq": "SPX Prerequisite: Completion of 050 Creative Arts Core"
        },
        "musi3327": {
            "Prereq": "SPX Prerequisite: Completion of 050 Creative Arts Core"
        },
        "musi3328": {
            "Prereq": "SPX Prerequisites: ((MUSI 2322 or equivalent) and (MUSI 2330 or equivalent)) or instructor consent required"
        },
        "musi3330": {
            "Prereq": "SPX Prerequisites: ((MUSI 2322 or eqivalent) and (MUSI 2330 or equivalent)) or instructor consent required"
        },
        "musi3342": {
            "Prereq": "SPX Prerequisite: Completion of 050 Creative Arts Core"
        },
        "musi3384": {
            "Prereq": "SPX Prerequisite: Audition or instructor consent required"
        },
        "musi3387": {
            "Prereq": "SPX Prerequisite: MUSI 2317 or equivalent or instructor consent required"
        },
        "musi3389": {
            "Prereq": "SPX Prerequisite: MUSI 2319 or instructor consent required"
        },
        "musi4185": {
            "Prereq": "SPX Prerequisite: Audition or instructor consent required"
        },
        "musi4348": {
            "Prereq": "SPX Prerequisite: MUSI 2328 or instructor consent required"
        },
        "musi4390": {
            "Prereq": "SPX Prerequisite: MUSI 3328 and MUSI 3330 and instructor consent required"
        },
        "musi4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "nats1101": {
            "Coreq": "UNIV 1010"
        },
        "nats1141": {
            "Prereq": "SPX Prerequisites: A university grade point average of at least 2"
        },
        "nats1142": {
            "Coreq": "UNIV 1010"
        },
        "nats1143": {
            "Prereq": "SPX Prerequisites: A university grade point average of at least 2"
        },
        "nats3341": {
            "Prereq": "SPX Prerequisites: A university grade point average (GPA) of at least 2"
        },
        "nats3343": {
            "Prereq": "SPX Prerequisites: A university grade point average (GPA) of at least 2"
        },
        "nats4141": {
            "Coreq": "NATS 4694 or NATS 4696"
        },
        "nats4341": {
            "PreOrCoreq": "NATS 4390 or MATH 3303"
        },
        "nats4390": {
            "PreOrCoreq": "NATS 3343"
        },
        "nats4694": {
            "Coreq": "NATS 4141"
        },
        "nats4696": {
            "Coreq": "NATS 4141"
        },
        "nsc4350": {
            "Prereq": "NSC 3361 and NSC 4366"
        },
        "nsc4351": {
            "Prereq": "NSC 3361"
        },
        "nsc4352": {
            "PreOrCoreq": "BIOL 2311"
        },
        "nsc4353": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311 and (MATH 2413 or MATH 2414 or MATH 2417)"
        },
        "nsc4354": {
            "Prereq": "NSC 3361"
        },
        "nsc4355": {
            "Prereq": "NSC 4353"
        },
        "nsc4356": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311 and (MATH 2413 or MATH 2414 or MATH 2417)"
        },
        "nsc4357": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311"
        },
        "nsc4358": {
            "Prereq": "NSC 3361"
        },
        "nsc4359": {
            "Prereq": "PSY 2301"
        },
        "nsc4360": {
            "Prereq": "ENTP 3301 and NSC 3361 and NSC 4352"
        },
        "nsc4362": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311"
        },
        "nsc4363": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311 and (MATH 2413 or MATH 2414 or MATH 2417)"
        },
        "nsc4364": {
            "Prereq": "NSC 3361"
        },
        "nsc4365": {
            "Prereq": "NSC 3361 and (NSC 4352 or NSC 4356)"
        },
        "nsc4366": {
            "Prereq": "NSC 3361 and CHEM 1311 and BIOL 2311"
        },
        "nsc4367": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311"
        },
        "nsc4370": {
            "Prereq": "NSC 4366"
        },
        "nsc4371": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311"
        },
        "nsc4372": {
            "Prereq": "NSC 3361"
        },
        "nsc4373": {
            "Prereq": "NSC 3361"
        },
        "nsc4374": {
            "Prereq": "NSC 4352"
        },
        "nsc4376": {
            "Prereq": "NSC 4354"
        },
        "nsc4378": {
            "Prereq": "NSC 4352 or NSC 4363"
        },
        "nsc4382": {
            "Prereq": "NSC 3361"
        },
        "nsc4383": {
            "Prereq": "NSC 3361 and NSC 4352 and CHEM 1311 and CHEM 1312 and BIOL 2311 and (MATH 2413 or MATH 2414 or MATH 2417)"
        },
        "nsc4385": {
            "Prereq": "NSC 3361"
        },
        "nsc4387": {
            "Prereq": "NSC 3361 and NSC 4366"
        },
        "nsc4388": {
            "Prereq": "NSC 3361 and NSC 4352"
        },
        "nsc4389": {
            "Prereq": "PSY 2301"
        },
        "nsc4395": {
            "Prereq": "SPX Prerequisites: NSC 4193 and a GPA of at least 2"
        },
        "obhr3311": {
            "Prereq": "SPX Prerequisite: Junior or Senior standing"
        },
        "obhr3320": {
            "Prereq": "OBHR 3310"
        },
        "obhr4300": {
            "Prereq": "SPX Prerequisite: Junior or Senior standing"
        },
        "obhr4310": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4331": {
            "Prereq": "OBHR 3330"
        },
        "obhr4333": {
            "Prereq": "OBHR 3330"
        },
        "obhr4334": {
            "Prereq": "OBHR 3330"
        },
        "obhr4335": {
            "Prereq": "OBHR 3330"
        },
        "obhr4336": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4337": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4338": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4350": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4352": {
            "Prereq": "SPX Prerequisites: Junior or Senior standing and (MATH 1325 or MATH 2413 or MATH 2417)"
        },
        "obhr4354": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4356": {
            "Prereq": "OBHR 3310 or OBHR 3330"
        },
        "obhr4358": {
            "Prereq": "(OBHR 3310 or OBHR 3330) and OBHR 4300 and OBHR 4350"
        },
        "obhr4361": {
            "Prereq": "OBHR 3330"
        },
        "obhr4370": {
            "Prereq": "SPX Prerequisite: OPRE 3360 or STAT 3360 or instructor consent required"
        },
        "obhr4395": {
            "Prereq": "SPX Prerequisites: (BCOM 4300 or BCOM 4350) and OBHR 3330 and any four of the HRM core (BLAW 3301 or OBHR 4331 or OBHR 4333 or OBHR 4334 or OBHR 4335 or OBHR 4354)"
        },
        "opre3100": {
            "Prereq": "BA 1100"
        },
        "opre3310": {
            "PreOrCoreq": "STAT 3360 or OPRE 3360"
        },
        "opre3312": {
            "Prereq": "ITSS 3311 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2333 or MATH 2418 or OPRE 3333)"
        },
        "opre3320": {
            "Prereq": "OPRE 3310"
        },
        "opre3333": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "opre3340": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "opre3360": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "opre4310": {
            "Prereq": "OPRE 3310"
        },
        "opre4320": {
            "Prereq": "ITSS 3300"
        },
        "opre4330": {
            "Prereq": "OPRE 3310 and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333) and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340)"
        },
        "opre4337": {
            "Prereq": "MKT 3300"
        },
        "opre4340": {
            "Prereq": "OPRE 3310 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340)"
        },
        "opre4350": {
            "Prereq": "(CS 2305 or MATH 2333 or MATH 2418 or OPRE 3333) and (OPRE 3360 or STAT 3360)"
        },
        "opre4353": {
            "Prereq": "ITSS 3312 and (MATH 1326 or MATH 2414 or MATH 2419 or OPRE 3340) and (CS 2305 or MATH 2418 or MATH 2333 or OPRE 3333)"
        },
        "opre4395": {
            "Prereq": "SPX Prerequisites: (BCOM 4300 or BCOM 4350) and OPRE 3310 or instructor consent required"
        },
        "pa3306": {
            "Prereq": "PA 2325 and EPPS 2301 and EPPS 2302"
        },
        "pa4317": {
            "Prereq": "SPX Prerequisite: PA 3381 or SOC 3381 and instructor consent required"
        },
        "phil3309": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3320": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3321": {
            "Prereq": "PHIL 1301 "
        },
        "phil3322": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3323": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3324": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3328": {
            "Prereq": "SPX Prerequisite: Upper-division standing or any previous PHIL course or completion of a 060 core course or instructor consent required"
        },
        "phil3338": {
            "Prereq": "SPX Prerequisite: LIT 2350 or equivalent or any previous PHIL course or instructor consent required"
        },
        "phil3357": {
            "Prereq": "SPX Prerequisites: Upper-division standing or any previous PHIL course or instructor consent required"
        },
        "phil3373": {
            "Prereq": "SPX externalism debate Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil3375": {
            "Prereq": "SPX Prerequisites: (Upper-division standing or any previous PHIL course) or instructor consent required"
        },
        "phil4308": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4321": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course or HIST 3328 or registered prehealth student"
        },
        "phil4322": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4323": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4324": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4325": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4326": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4327": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4328": {
            "Prereq": "SPX Prerequisite: PHIL 3321 and instructor consent required"
        },
        "phil4330": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4331": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course or LIT 3314 or CRWT 3351"
        },
        "phil4332": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4333": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4344": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course or HIST 3328 or upper-division coursework in the sciences"
        },
        "phil4380": {
            "Prereq": "SPX Prerequisite: Any previous PHIL course"
        },
        "phil4v99": {
            "Prereq": "SPX Prerequisite: Instructor consent required"
        },
        "phin2120": {
            "Prereq": "SPX Recommended Prerequisites: You must be able to swim and tread water"
        },
        "phys1301": {
            "Coreq": "PHYS 2125"
        },
        "phys1302": {
            "Coreq": "PHYS 2126"
        },
        "phys2125": {
            "Coreq": "PHYS 1301 or PHYS 2325 or PHYS 2421"
        },
        "phys2126": {
            "Coreq": "PHYS 1302 or PHYS 2326 or PHYS 2422"
        },
        "phys2325": {
            "Coreq": "(MATH 2414 or MATH 2419) and (PHYS 2121 or PHYS 2125)"
        },
        "phys2326": {
            "Coreq": "PHYS 2126"
        },
        "phys2421": {
            "Coreq": "(MATH 2414 or MATH 2419)"
        },
        "phys2422": {
            "Coreq": "(MATH 2415 or MATH 2451 or MATH 3351) and PHYS 2126"
        },
        "phys3312": {
            "Prereq": "PHYS 3311 or PHYS 3411 "
        },
        "phys3330": {
            "Prereq": "(MATH 2415 or MATH 2419 ) and MATH 2418"
        },
        "phys3380": {
            "Prereq": "PHYS 2326 or PHYS 2422"
        },
        "phys3411": {
            "Prereq": "SPX Prerequisites: MATH 2418 with a grade of at least C- and (MATH 2415 or MATH 3351 with a grade of at least B- or MATH 2451 with a grade of at least C-) and (PHYS 2326 or PHYS 2422)"
        },
        "phys3416": {
            "Prereq": "PHYS 3311 or PHYS 3411 "
        },
        "phys3427": {
            "Prereq": "PHYS 2326 or PHYS 2422"
        },
        "phys4301": {
            "Prereq": "(PHYS 3311 or PHYS 3411) and MATH 2418"
        },
        "phys4302": {
            "Prereq": "PHYS 4301"
        },
        "phys4311": {
            "Prereq": "PHYS 2325 or PHYS 2421"
        },
        "phys4319": {
            "Prereq": "PHYS 2326"
        },
        "phys4328": {
            "Prereq": "PHYS 3416"
        },
        "phys4352": {
            "Prereq": "PHYS 4302"
        },
        "phys4371": {
            "Prereq": "PHYS 3416 and PHYS 4301"
        },
        "phys4373": {
            "Prereq": "PHYS 3416"
        },
        "phys4386": {
            "Prereq": "PHYS 4301 and PHYS 4311"
        },
        "phys4392": {
            "Prereq": "PHYS 2326 or PHYS 2422"
        },
        "ppol4300": {
            "Prereq": "EPPS 2301 and EPPS 2302"
        },
        "psci3325": {
            "Prereq": "SPX Prerequisites: GOVT 2305 and GOVT 2306 or equivalent or instructor consent required"
        },
        "psci3362": {
            "Prereq": "SPX Prerequisites: GOVT 2305 and GOVT 2306 or equivalent or instructor consent required"
        },
        "psci4305": {
            "Prereq": "EPPS 2301 and EPPS 2302"
        },
        "psci4307": {
            "Prereq": "EPPS 2301 and EPPS 2302"
        },
        "psci4356": {
            "Prereq": "SPX Prerequisite: PSCI 3328 or PSCI 4329 or undergraduate coursework in international economics"
        },
        "psy2317": {
            "Prereq": "MATH 1306 or MATH 1314 "
        },
        "psy3100": {
            "Prereq": "PSY 2301"
        },
        "psy3332": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "psy3333": {
            "Prereq": "PSY 2301"
        },
        "psy3336": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "psy3342": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "psy3360": {
            "Prereq": "PSY 2301 or CGS 2301"
        },
        "psy3361": {
            "Prereq": "PSY 2301 or CGS 2301"
        },
        "psy3362": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "psy3366": {
            "Prereq": "CLDP 3339 or PSY 3339"
        },
        "psy3392": {
            "Prereq": "PSY 2317 or STAT 1342 "
        },
        "psy3393": {
            "Prereq": "PSY 3392 or PSY 3490"
        },
        "psy3490": {
            "Prereq": "SPX Prerequisite: Grade of B+ or better in MATH 1306 or MATH 1314 or higher"
        },
        "psy4320": {
            "Prereq": "PSY 2301 or PSY 3361"
        },
        "psy4324": {
            "Prereq": "PSY 2301"
        },
        "psy4327": {
            "Prereq": "PSY 2301"
        },
        "psy4328": {
            "Prereq": "PSY 2301"
        },
        "psy4331": {
            "Prereq": "PSY 2301"
        },
        "psy4332": {
            "Prereq": "PSY 2301"
        },
        "psy4333": {
            "Prereq": "PSY 2301"
        },
        "psy4344": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "psy4352": {
            "Prereq": "PSY 2301"
        },
        "psy4359": {
            "Prereq": "PSY 2301"
        },
        "psy4362": {
            "Prereq": "CGS 2301 or PSY 2301"
        },
        "psy4364": {
            "Prereq": "SPX Prerequisite: (CGS 3361 or PSY 3361) or instructor consent required"
        },
        "psy4370": {
            "Prereq": "PSY 2301"
        },
        "psy4372": {
            "Prereq": "PSY 2301"
        },
        "psy4373": {
            "Prereq": "PSY 2301"
        },
        "psy4378": {
            "PreOrCoreq": "PSY 4377"
        },
        "psy4385": {
            "Prereq": "NSC 3361"
        },
        "psy4386": {
            "Prereq": "PSY 2301"
        },
        "psy4389": {
            "Prereq": "PSY 2301"
        },
        "real3365": {
            "Prereq": "FIN 3320"
        },
        "real4321": {
            "PreOrCoreq": "FIN 3305 or REAL 3305"
        },
        "real4328": {
            "Prereq": "((REAL 3305 or FIN 3305) or (REAL 3365 or FIN 3365)) and FIN 3320"
        },
        "real4v90": {
            "Prereq": "SPX Prerequisites: REAL 3365 and faculty sponsor approval"
        },
        "rhet2302": {
            "Prereq": "SPX Prerequisite: RHET 1302 or instructor consent required"
        },
        "rhet3302": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and RHET 2302) or instructor consent required"
        },
        "rhet3303": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and RHET 2302) or instructor consent required"
        },
        "rhet4302": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and RHET 2302) or instructor consent required"
        },
        "rhet4303": {
            "Prereq": "SPX Prerequisites: (RHET 1302 and RHET 2302) or instructor consent required"
        },
        "rmis3370": {
            "Prereq": "MATH 1325 or MATH 2413 or MATH 2417"
        },
        "rmis3375": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "rmis4331": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "rmis4332": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "rmis4333": {
            "PreOrCoreq": "RMIS 4331 or RMIS 4332"
        },
        "rmis4334": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "rmis4336": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "rmis4338": {
            "PreOrCoreq": "FIN 3320 or FIN 3370 or RMIS 3370"
        },
        "se3162": {
            "PreOrCoreq": "CS 3345 and CS 3354"
        },
        "se3306": {
            "Prereq": "(CE 2305 or CS 2305) "
        },
        "se3341": {
            "Prereq": "(MATH 1326 or MATH 2414 or MATH 2419) and (CE 2305 or CS 2305) "
        },
        "se3345": {
            "PreOrCoreq": "(CS 3341 or SE 3341 or ENGR 3341)"
        },
        "se3354": {
            "PreOrCoreq": "ECS 3390"
        },
        "se3377": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337) "
        },
        "se4347": {
            "Prereq": "CE 3345 or CS 3345 or SE 3345"
        },
        "se4348": {
            "Prereq": "(CS 2340 or SE 3340)  and (CS 3377 or SE 3377) and (CE 3345 or CS 3345 or SE 3345)"
        },
        "se4351": {
            "Prereq": "SPX Prerequisites: SE 3306 and (CE 3354 or CS 3354 or SE 3354) or instructor consent required"
        },
        "se4352": {
            "Prereq": "SPX Prerequisites: SE 3306 and (CE 3354 or CS 3354 or SE 3354) or instructor consent required"
        },
        "se4367": {
            "Prereq": "SPX Prerequisites: SE 3306 and (CE 3354 or CS 3354 or SE 3354) or instructor consent required"
        },
        "se4376": {
            "Prereq": "(CE 2336 or CS 2336 or CS 2337) "
        },
        "se4381": {
            "Prereq": "CE 3354 or CS 3354 or SE 3354"
        },
        "se4485": {
            "Prereq": "SE 4351 or SE 4352 or SE 4367 or SE 4381"
        },
        "se4v95": {
            "Prereq": "CE 3345 or CS 3345 or SE 3345"
        },
        "soc3303": {
            "Prereq": "SOC 1301"
        },
        "soc3305": {
            "Prereq": "EPPS 2301 and EPPS 2302"
        },
        "soc4302": {
            "Prereq": "SOC 1301 or SOC 3303"
        },
        "soc4306": {
            "Prereq": "SOC 3303 and SOC 3305"
        },
        "soc4317": {
            "Prereq": "SPX Prerequisite: PA 3381 or SOC 3381 and instructor consent required"
        },
        "span1311": {
            "Prereq": "SPX Prerequisite: Equivalent based on placement exam score or instructor consent required"
        },
        "span1312": {
            "Prereq": "SPX Prerequisite: SPAN 1311 or equivalent based on placement exam score or instructor consent required"
        },
        "span2310": {
            "Prereq": "SPX Prerequisite: Equivalent based on placement exam score or instructor consent required"
        },
        "span2311": {
            "Prereq": "SPX Prerequisite: SPAN 1312 or equivalent based on placement exam or instructor consent required"
        },
        "span2312": {
            "Prereq": "SPX Prerequisite: SPAN 2311 or equivalent based on placement exam or instructor consent required"
        },
        "span3330": {
            "Prereq": "SPX Prerequisite: SPAN 2312 or equivalent based on placement exam or instructor consent required"
        },
        "span3350": {
            "Prereq": "SPX Prerequisite: SPAN 2312 or equivalent based on placement exam or instructor consent required"
        },
        "span3363": {
            "Prereq": "SPX Prerequisite: SPAN 2312 or equivalent based on placement exam or instructor consent required"
        },
        "span3365": {
            "Prereq": "SPX Prerequisite: SPAN 2312 or equivalent based on placement exam or instructor consent required"
        },
        "span3366": {
            "Prereq": "SPX Prerequisite: SPAN 3365 or equivalent based on placement exam or instructor consent required"
        },
        "span4301": {
            "Prereq": "SPX Prerequisite: SPAN 3366 or equivalent based on placement exam or instructor consent required"
        },
        "span4302": {
            "Prereq": "SPX Prerequisite: SPAN 3366 or equivalent based on placement exam or instructor consent required"
        },
        "span4364": {
            "Prereq": "SPX Prerequisite: SPAN 3366 or equivalent based on placement exam or instructor consent required"
        },
        "span4366": {
            "Prereq": "SPX Prerequisite: SPAN 3366 or equivalent based on placement exam score or instructor consent required"
        },
        "span4367": {
            "Prereq": "SPX Prerequisite: SPAN 3366, or completion of the language placement exam or instructor consent required"
        },
        "spau3340": {
            "PreOrCoreq": "SPAU 3343"
        },
        "spau3341": {
            "PreOrCoreq": "SPX Prerequisites or Corequisites: SPAU 3304 and SPAU 3344 or instructor consent required"
        },
        "spau3342": {
            "Prereq": "(CLDP 2314 or PSY 2314) or (CLDP 3310 or PSY 3310) or (CLDP 3339 or PSY 3339) "
        },
        "spau3390": {
            "Prereq": "SPX Prerequisites: SPAU 3301 and SPAU 3303 and SPAU 3388 and SPAU 3340 and SPAU 3343 and SPAU 4308 and instructor consent required"
        },
        "spau4308": {
            "Prereq": "SPX Prerequisite: CLDP 3303 or SPAU 3303 or instructor consent required"
        },
        "spau4342": {
            "Prereq": "SPX Prerequisite: SPAU 3301 or instructor consent required"
        },
        "spau4386": {
            "Prereq": "PSY 2301"
        },
        "stat1342": {
            "Prereq": "MATH 1306 or MATH 1314 "
        },
        "stat2332": {
            "Prereq": "MATH 1325 or MATH 2312 "
        },
        "stat3332": {
            "Prereq": "MATH 2312 or MATH 1325 "
        },
        "stat3341": {
            "Prereq": "(MATH 1326 or MATH 2414 or MATH 2419) and (CE 2305 or CS 2305) "
        },
        "stat3355": {
            "Prereq": "MATH 2415 or MATH 2419 "
        },
        "stat3360": {
            "Prereq": "MATH 1326"
        },
        "stat4351": {
            "Prereq": "MATH 2451 or MATH 3351"
        },
        "stat4352": {
            "Prereq": "STAT 4351 "
        },
        "stat4354": {
            "Prereq": "SPX Prerequisites: (MATH 2451 or MATH 3351) and STAT 4351, or instructor consent required"
        },
        "stat4355": {
            "Prereq": "SPX Prerequisite: STAT 3355 or instructor consent required"
        },
        "stat4360": {
            "Prereq": "SPX Prerequisites: STAT 4355 or instructor consent required"
        },
        "stat4382": {
            "Prereq": "STAT 4351 "
        },
        "stat4475": {
            "Prereq": "STAT 4355 and CS 4375"
        },
        "thea1352": {
            "Prereq": "SPX Prerequisite: THEA 1351 or instructor consent required"
        },
        "thea2373": {
            "Prereq": "SPX Prerequisite: THEA 1310 or instructor consent required"
        },
        "thea3310": {
            "Prereq": "SPX Prerequisite: Audition or instructor consent required"
        },
        "thea3323": {
            "Prereq": "SPX Prerequisite: THEA 1310 or instructor consent required"
        },
        "thea3324": {
            "Prereq": "SPX Prerequisite: THEA 2371 or instructor consent required"
        },
        "thea3325": {
            "Prereq": "SPX Prerequisite: THEA 1351 or instructor consent required"
        },
        "thea3342": {
            "Prereq": "SPX Prerequisite: THEA 1310 or instructor consent required"
        },
        "thea3351": {
            "Prereq": "SPX Prerequisite: (THEA 1310 and THEA 3324) or instructor consent required"
        },
        "thea3352": {
            "Prereq": "SPX Prerequisite: THEA 2371 or instructor consent required"
        },
        "thea3356": {
            "Prereq": "SPX Prerequisite: Audition or instructor consent required"
        },
        "thea3372": {
            "Prereq": "SPX Prerequisite: THEA 2372 or instructor consent required"
        },
        "thea3380": {
            "Prereq": "SPX Prerequisite: THEA 1310 or instructor consent required"
        },
        "thea4301": {
            "Prereq": "SPX Prerequisite: (THEA 1351 or equivalent) or instructor consent required"
        },
        "thea4310": {
            "Prereq": "SPX Prerequisites: (THEA 1351 and THEA 1352 and THEA 3356) or (THEA 2371 and THEA 3324 and THEA 3351) and instructor consent required"
        },
        "thea4342": {
            "Prereq": "SPX Prerequisites: (THEA 2371 and THEA 3324 and THEA 3351) or instructor consent required"
        },
        "thea4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        },
        "univ1010": {
            "Coreq": "ARHM 1100 or ATCM 1100 or BA 1100 or BBSU 1100 or BCOM 1300 or BIS 1100 or ECS 1100 or EPPS 1110 or NATS 1101 or NATS 1142 or UNIV 1100"
        },
        "univ1100": {
            "Coreq": "UNIV 1010"
        },
        "univ2010": {
            "Prereq": "SPX Prerequisites: Sophomore standing and instructor consent required"
        },
        "univ2012": {
            "Prereq": "SPX Prerequisite: Junior standing"
        },
        "univ4174": {
            "Prereq": "UNIV 4074"
        },
        "vpas3300": {
            "Prereq": "SPX Prerequisites: Completion of 050 core and School of Arts and Humanities major"
        },
        "vpas3340": {
            "Prereq": "RHET 1302 "
        },
        "vpas4310": {
            "Prereq": "SPX Prerequisites: (Completion of 050 core and RHET 1302 and COMM 1311) or instructor consent required"
        },
        "vpas4389": {
            "Prereq": "SPX Prerequisites: VPAS 3340 and Senior standing in a Visual and Performing Arts major"
        },
        "vpas4390": {
            "Prereq": "SPX Prerequisites: VPAS 4389 and instructor consent required"
        },
        "vpas4v71": {
            "Prereq": "SPX Prerequisites: Upper-division standing and instructor consent required"
        }
    }
];